var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/runtime.ts
var BASE_PATH = "http://localhost/partner/air/v4.0".replace(/\/+$/, "");
var Configuration = class {
  constructor(configuration = {}) {
    this.configuration = configuration;
  }
  set config(configuration) {
    this.configuration = configuration;
  }
  get basePath() {
    return this.configuration.basePath != null ? this.configuration.basePath : BASE_PATH;
  }
  get fetchApi() {
    return this.configuration.fetchApi;
  }
  get middleware() {
    return this.configuration.middleware || [];
  }
  get queryParamsStringify() {
    return this.configuration.queryParamsStringify || querystring;
  }
  get username() {
    return this.configuration.username;
  }
  get password() {
    return this.configuration.password;
  }
  get apiKey() {
    const apiKey = this.configuration.apiKey;
    if (apiKey) {
      return typeof apiKey === "function" ? apiKey : () => apiKey;
    }
    return void 0;
  }
  get accessToken() {
    const accessToken = this.configuration.accessToken;
    if (accessToken) {
      return typeof accessToken === "function" ? accessToken : () => __async(this, null, function* () {
        return accessToken;
      });
    }
    return void 0;
  }
  get headers() {
    return this.configuration.headers;
  }
  get credentials() {
    return this.configuration.credentials;
  }
};
var DefaultConfig = new Configuration();
var _BaseAPI = class _BaseAPI {
  constructor(configuration = DefaultConfig) {
    this.configuration = configuration;
    this.fetchApi = (url, init) => __async(this, null, function* () {
      let fetchParams = { url, init };
      for (const middleware of this.middleware) {
        if (middleware.pre) {
          fetchParams = (yield middleware.pre(__spreadValues({
            fetch: this.fetchApi
          }, fetchParams))) || fetchParams;
        }
      }
      let response = void 0;
      try {
        response = yield (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
      } catch (e) {
        for (const middleware of this.middleware) {
          if (middleware.onError) {
            response = (yield middleware.onError({
              fetch: this.fetchApi,
              url: fetchParams.url,
              init: fetchParams.init,
              error: e,
              response: response ? response.clone() : void 0
            })) || response;
          }
        }
        if (response === void 0) {
          if (e instanceof Error) {
            throw new FetchError(e, "The request failed and the interceptors did not return an alternative response");
          } else {
            throw e;
          }
        }
      }
      for (const middleware of this.middleware) {
        if (middleware.post) {
          response = (yield middleware.post({
            fetch: this.fetchApi,
            url: fetchParams.url,
            init: fetchParams.init,
            response: response.clone()
          })) || response;
        }
      }
      return response;
    });
    this.middleware = configuration.middleware;
  }
  withMiddleware(...middlewares) {
    const next = this.clone();
    next.middleware = next.middleware.concat(...middlewares);
    return next;
  }
  withPreMiddleware(...preMiddlewares) {
    const middlewares = preMiddlewares.map((pre) => ({ pre }));
    return this.withMiddleware(...middlewares);
  }
  withPostMiddleware(...postMiddlewares) {
    const middlewares = postMiddlewares.map((post) => ({ post }));
    return this.withMiddleware(...middlewares);
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(mime) {
    if (!mime) {
      return false;
    }
    return _BaseAPI.jsonRegex.test(mime);
  }
  request(context, initOverrides) {
    return __async(this, null, function* () {
      const { url, init } = yield this.createFetchParams(context, initOverrides);
      const response = yield this.fetchApi(url, init);
      if (response && (response.status >= 200 && response.status < 300)) {
        return response;
      }
      throw new ResponseError(response, "Response returned an error code");
    });
  }
  createFetchParams(context, initOverrides) {
    return __async(this, null, function* () {
      let url = this.configuration.basePath + context.path;
      if (context.query !== void 0 && Object.keys(context.query).length !== 0) {
        url += "?" + this.configuration.queryParamsStringify(context.query);
      }
      const headers = Object.assign({}, this.configuration.headers, context.headers);
      Object.keys(headers).forEach((key) => headers[key] === void 0 ? delete headers[key] : {});
      const initOverrideFn = typeof initOverrides === "function" ? initOverrides : () => __async(this, null, function* () {
        return initOverrides;
      });
      const initParams = {
        method: context.method,
        headers,
        body: context.body,
        credentials: this.configuration.credentials
      };
      const overriddenInit = __spreadValues(__spreadValues({}, initParams), yield initOverrideFn({
        init: initParams,
        context
      }));
      let body;
      if (isFormData(overriddenInit.body) || overriddenInit.body instanceof URLSearchParams || isBlob(overriddenInit.body)) {
        body = overriddenInit.body;
      } else if (this.isJsonMime(headers["Content-Type"])) {
        body = JSON.stringify(overriddenInit.body);
      } else {
        body = overriddenInit.body;
      }
      const init = __spreadProps(__spreadValues({}, overriddenInit), {
        body
      });
      return { url, init };
    });
  }
  /**
   * Create a shallow clone of `this` by constructing a new instance
   * and then shallow cloning data members.
   */
  clone() {
    const constructor = this.constructor;
    const next = new constructor(this.configuration);
    next.middleware = this.middleware.slice();
    return next;
  }
};
_BaseAPI.jsonRegex = new RegExp("^(:?application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(:?;.*)?$", "i");
var BaseAPI = _BaseAPI;
function isBlob(value) {
  return typeof Blob !== "undefined" && value instanceof Blob;
}
function isFormData(value) {
  return typeof FormData !== "undefined" && value instanceof FormData;
}
var ResponseError = class extends Error {
  constructor(response, msg) {
    super(msg);
    this.response = response;
    this.name = "ResponseError";
  }
};
var FetchError = class extends Error {
  constructor(cause, msg) {
    super(msg);
    this.cause = cause;
    this.name = "FetchError";
  }
};
var RequiredError = class extends Error {
  constructor(field, msg) {
    super(msg);
    this.field = field;
    this.name = "RequiredError";
  }
};
var COLLECTION_FORMATS = {
  csv: ",",
  ssv: " ",
  tsv: "	",
  pipes: "|"
};
function exists(json, key) {
  const value = json[key];
  return value !== null && value !== void 0;
}
function querystring(params, prefix = "") {
  return Object.keys(params).map((key) => querystringSingleKey(key, params[key], prefix)).filter((part) => part.length > 0).join("&");
}
function querystringSingleKey(key, value, keyPrefix = "") {
  const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
  if (value instanceof Array) {
    const multiValue = value.map((singleValue) => encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
    return `${encodeURIComponent(fullKey)}=${multiValue}`;
  }
  if (value instanceof Set) {
    const valueAsArray = Array.from(value);
    return querystringSingleKey(key, valueAsArray, keyPrefix);
  }
  if (value instanceof Date) {
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
  }
  if (value instanceof Object) {
    return querystring(value, fullKey);
  }
  return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}
function mapValues(data, fn) {
  return Object.keys(data).reduce(
    (acc, key) => __spreadProps(__spreadValues({}, acc), { [key]: fn(data[key]) }),
    {}
  );
}
function canConsumeForm(consumes) {
  for (const consume of consumes) {
    if ("multipart/form-data" === consume.contentType) {
      return true;
    }
  }
  return false;
}
var JSONApiResponse = class {
  constructor(raw, transformer = (jsonValue) => jsonValue) {
    this.raw = raw;
    this.transformer = transformer;
  }
  value() {
    return __async(this, null, function* () {
      return this.transformer(yield this.raw.json());
    });
  }
};
var VoidApiResponse = class {
  constructor(raw) {
    this.raw = raw;
  }
  value() {
    return __async(this, null, function* () {
      return void 0;
    });
  }
};
var BlobApiResponse = class {
  constructor(raw) {
    this.raw = raw;
  }
  value() {
    return __async(this, null, function* () {
      return yield this.raw.blob();
    });
  }
};
var TextApiResponse = class {
  constructor(raw) {
    this.raw = raw;
  }
  value() {
    return __async(this, null, function* () {
      return yield this.raw.text();
    });
  }
};

// src/models/ContractNotFound.ts
function instanceOfContractNotFound(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function ContractNotFoundFromJSON(json) {
  return ContractNotFoundFromJSONTyped(json, false);
}
function ContractNotFoundFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function ContractNotFoundToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/OfferNotFound.ts
function instanceOfOfferNotFound(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function OfferNotFoundFromJSON(json) {
  return OfferNotFoundFromJSONTyped(json, false);
}
function OfferNotFoundFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function OfferNotFoundToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/UnsupportedPriceFreezeOfferType.ts
function instanceOfUnsupportedPriceFreezeOfferType(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function UnsupportedPriceFreezeOfferTypeFromJSON(json) {
  return UnsupportedPriceFreezeOfferTypeFromJSONTyped(json, false);
}
function UnsupportedPriceFreezeOfferTypeFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function UnsupportedPriceFreezeOfferTypeToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/AnalyticsApplicationError.ts
function AnalyticsApplicationErrorFromJSON(json) {
  return AnalyticsApplicationErrorFromJSONTyped(json, false);
}
function AnalyticsApplicationErrorFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["code"]) {
    case "contract_not_found":
      return __spreadProps(__spreadValues({}, ContractNotFoundFromJSONTyped(json, true)), { code: "contract_not_found" });
    case "offer_not_found":
      return __spreadProps(__spreadValues({}, OfferNotFoundFromJSONTyped(json, true)), { code: "offer_not_found" });
    case "unsupported_price_freeze_offer_type":
      return __spreadProps(__spreadValues({}, UnsupportedPriceFreezeOfferTypeFromJSONTyped(json, true)), { code: "unsupported_price_freeze_offer_type" });
    default:
      throw new Error(`No variant of AnalyticsApplicationError exists with 'code=${json["code"]}'`);
  }
}
function AnalyticsApplicationErrorToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["code"]) {
    case "contract_not_found":
      return ContractNotFoundToJSON(value);
    case "offer_not_found":
      return OfferNotFoundToJSON(value);
    case "unsupported_price_freeze_offer_type":
      return UnsupportedPriceFreezeOfferTypeToJSON(value);
    default:
      throw new Error(`No variant of AnalyticsApplicationError exists with 'code=${value["code"]}'`);
  }
}

// src/models/Luggage.ts
function instanceOfLuggage(value) {
  let isInstance = true;
  isInstance = isInstance && "total_price" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function LuggageFromJSON(json) {
  return LuggageFromJSONTyped(json, false);
}
function LuggageFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "total_price": json["total_price"],
    "type": json["type"]
  };
}
function LuggageToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "total_price": value.total_price,
    "type": value.type
  };
}

// src/models/SeatSelection.ts
function instanceOfSeatSelection(value) {
  let isInstance = true;
  isInstance = isInstance && "total_price" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function SeatSelectionFromJSON(json) {
  return SeatSelectionFromJSONTyped(json, false);
}
function SeatSelectionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "total_price": json["total_price"],
    "type": json["type"]
  };
}
function SeatSelectionToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "total_price": value.total_price,
    "type": value.type
  };
}

// src/models/TravelInsurance.ts
function instanceOfTravelInsurance(value) {
  let isInstance = true;
  isInstance = isInstance && "total_price" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function TravelInsuranceFromJSON(json) {
  return TravelInsuranceFromJSONTyped(json, false);
}
function TravelInsuranceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "total_price": json["total_price"],
    "type": json["type"]
  };
}
function TravelInsuranceToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "total_price": value.total_price,
    "type": value.type
  };
}

// src/models/Unclassified.ts
function instanceOfUnclassified(value) {
  let isInstance = true;
  isInstance = isInstance && "total_price" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function UnclassifiedFromJSON(json) {
  return UnclassifiedFromJSONTyped(json, false);
}
function UnclassifiedFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "total_price": json["total_price"],
    "type": json["type"]
  };
}
function UnclassifiedToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "total_price": value.total_price,
    "type": value.type
  };
}

// src/models/Ancillary.ts
function AncillaryFromJSON(json) {
  return AncillaryFromJSONTyped(json, false);
}
function AncillaryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "luggage":
      return __spreadProps(__spreadValues({}, LuggageFromJSONTyped(json, true)), { type: "luggage" });
    case "seat_selection":
      return __spreadProps(__spreadValues({}, SeatSelectionFromJSONTyped(json, true)), { type: "seat_selection" });
    case "travel_insurance":
      return __spreadProps(__spreadValues({}, TravelInsuranceFromJSONTyped(json, true)), { type: "travel_insurance" });
    case "unclassified":
      return __spreadProps(__spreadValues({}, UnclassifiedFromJSONTyped(json, true)), { type: "unclassified" });
    default:
      throw new Error(`No variant of Ancillary exists with 'type=${json["type"]}'`);
  }
}
function AncillaryToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "luggage":
      return LuggageToJSON(value);
    case "seat_selection":
      return SeatSelectionToJSON(value);
    case "travel_insurance":
      return TravelInsuranceToJSON(value);
    case "unclassified":
      return UnclassifiedToJSON(value);
    default:
      throw new Error(`No variant of Ancillary exists with 'type=${value["type"]}'`);
  }
}

// src/models/Android.ts
function instanceOfAndroid(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function AndroidFromJSON(json) {
  return AndroidFromJSONTyped(json, false);
}
function AndroidFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "version": !exists(json, "version") ? void 0 : json["version"],
    "type": json["type"]
  };
}
function AndroidToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "version": value.version,
    "type": value.type
  };
}

// src/models/ChromeOs.ts
function instanceOfChromeOs(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function ChromeOsFromJSON(json) {
  return ChromeOsFromJSONTyped(json, false);
}
function ChromeOsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "version": !exists(json, "version") ? void 0 : json["version"],
    "type": json["type"]
  };
}
function ChromeOsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "version": value.version,
    "type": value.type
  };
}

// src/models/IOs.ts
function instanceOfIOs(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function IOsFromJSON(json) {
  return IOsFromJSONTyped(json, false);
}
function IOsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "version": !exists(json, "version") ? void 0 : json["version"],
    "type": json["type"]
  };
}
function IOsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "version": value.version,
    "type": value.type
  };
}

// src/models/Linux.ts
function instanceOfLinux(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function LinuxFromJSON(json) {
  return LinuxFromJSONTyped(json, false);
}
function LinuxFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "version": !exists(json, "version") ? void 0 : json["version"],
    "type": json["type"]
  };
}
function LinuxToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "version": value.version,
    "type": value.type
  };
}

// src/models/MacOs.ts
function instanceOfMacOs(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function MacOsFromJSON(json) {
  return MacOsFromJSONTyped(json, false);
}
function MacOsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "version": !exists(json, "version") ? void 0 : json["version"],
    "type": json["type"]
  };
}
function MacOsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "version": value.version,
    "type": value.type
  };
}

// src/models/OtherOs.ts
function instanceOfOtherOs(value) {
  let isInstance = true;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function OtherOsFromJSON(json) {
  return OtherOsFromJSONTyped(json, false);
}
function OtherOsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "version": !exists(json, "version") ? void 0 : json["version"],
    "type": json["type"]
  };
}
function OtherOsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "version": value.version,
    "type": value.type
  };
}

// src/models/Windows.ts
function instanceOfWindows(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function WindowsFromJSON(json) {
  return WindowsFromJSONTyped(json, false);
}
function WindowsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "version": !exists(json, "version") ? void 0 : json["version"],
    "type": json["type"]
  };
}
function WindowsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "version": value.version,
    "type": value.type
  };
}

// src/models/OperatingSystem.ts
function OperatingSystemFromJSON(json) {
  return OperatingSystemFromJSONTyped(json, false);
}
function OperatingSystemFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "android":
      return __spreadProps(__spreadValues({}, AndroidFromJSONTyped(json, true)), { type: "android" });
    case "chrome_os":
      return __spreadProps(__spreadValues({}, ChromeOsFromJSONTyped(json, true)), { type: "chrome_os" });
    case "i_os":
      return __spreadProps(__spreadValues({}, IOsFromJSONTyped(json, true)), { type: "i_os" });
    case "linux":
      return __spreadProps(__spreadValues({}, LinuxFromJSONTyped(json, true)), { type: "linux" });
    case "mac_os":
      return __spreadProps(__spreadValues({}, MacOsFromJSONTyped(json, true)), { type: "mac_os" });
    case "other_os":
      return __spreadProps(__spreadValues({}, OtherOsFromJSONTyped(json, true)), { type: "other_os" });
    case "windows":
      return __spreadProps(__spreadValues({}, WindowsFromJSONTyped(json, true)), { type: "windows" });
    default:
      throw new Error(`No variant of OperatingSystem exists with 'type=${json["type"]}'`);
  }
}
function OperatingSystemToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "android":
      return AndroidToJSON(value);
    case "chrome_os":
      return ChromeOsToJSON(value);
    case "i_os":
      return IOsToJSON(value);
    case "linux":
      return LinuxToJSON(value);
    case "mac_os":
      return MacOsToJSON(value);
    case "other_os":
      return OtherOsToJSON(value);
    case "windows":
      return WindowsToJSON(value);
    default:
      throw new Error(`No variant of OperatingSystem exists with 'type=${value["type"]}'`);
  }
}

// src/models/App.ts
function instanceOfApp(value) {
  let isInstance = true;
  isInstance = isInstance && "operating_system" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function AppFromJSON(json) {
  return AppFromJSONTyped(json, false);
}
function AppFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "operating_system": OperatingSystemFromJSON(json["operating_system"]),
    "type": json["type"]
  };
}
function AppToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "operating_system": OperatingSystemToJSON(value.operating_system),
    "type": value.type
  };
}

// src/models/Chrome.ts
function instanceOfChrome(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function ChromeFromJSON(json) {
  return ChromeFromJSONTyped(json, false);
}
function ChromeFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "version": !exists(json, "version") ? void 0 : json["version"],
    "type": json["type"]
  };
}
function ChromeToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "version": value.version,
    "type": value.type
  };
}

// src/models/Edge.ts
function instanceOfEdge(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function EdgeFromJSON(json) {
  return EdgeFromJSONTyped(json, false);
}
function EdgeFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "version": !exists(json, "version") ? void 0 : json["version"],
    "type": json["type"]
  };
}
function EdgeToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "version": value.version,
    "type": value.type
  };
}

// src/models/Firefox.ts
function instanceOfFirefox(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function FirefoxFromJSON(json) {
  return FirefoxFromJSONTyped(json, false);
}
function FirefoxFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "version": !exists(json, "version") ? void 0 : json["version"],
    "type": json["type"]
  };
}
function FirefoxToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "version": value.version,
    "type": value.type
  };
}

// src/models/InternetExplorer.ts
function instanceOfInternetExplorer(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function InternetExplorerFromJSON(json) {
  return InternetExplorerFromJSONTyped(json, false);
}
function InternetExplorerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "version": !exists(json, "version") ? void 0 : json["version"],
    "type": json["type"]
  };
}
function InternetExplorerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "version": value.version,
    "type": value.type
  };
}

// src/models/Opera.ts
function instanceOfOpera(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function OperaFromJSON(json) {
  return OperaFromJSONTyped(json, false);
}
function OperaFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "version": !exists(json, "version") ? void 0 : json["version"],
    "type": json["type"]
  };
}
function OperaToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "version": value.version,
    "type": value.type
  };
}

// src/models/OtherBrowser.ts
function instanceOfOtherBrowser(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function OtherBrowserFromJSON(json) {
  return OtherBrowserFromJSONTyped(json, false);
}
function OtherBrowserFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "version": !exists(json, "version") ? void 0 : json["version"],
    "type": json["type"]
  };
}
function OtherBrowserToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "version": value.version,
    "type": value.type
  };
}

// src/models/Safari.ts
function instanceOfSafari(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function SafariFromJSON(json) {
  return SafariFromJSONTyped(json, false);
}
function SafariFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "version": !exists(json, "version") ? void 0 : json["version"],
    "type": json["type"]
  };
}
function SafariToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "version": value.version,
    "type": value.type
  };
}

// src/models/Browser.ts
function BrowserFromJSON(json) {
  return BrowserFromJSONTyped(json, false);
}
function BrowserFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "chrome":
      return __spreadProps(__spreadValues({}, ChromeFromJSONTyped(json, true)), { type: "chrome" });
    case "edge":
      return __spreadProps(__spreadValues({}, EdgeFromJSONTyped(json, true)), { type: "edge" });
    case "firefox":
      return __spreadProps(__spreadValues({}, FirefoxFromJSONTyped(json, true)), { type: "firefox" });
    case "internet_explorer":
      return __spreadProps(__spreadValues({}, InternetExplorerFromJSONTyped(json, true)), { type: "internet_explorer" });
    case "opera":
      return __spreadProps(__spreadValues({}, OperaFromJSONTyped(json, true)), { type: "opera" });
    case "other_browser":
      return __spreadProps(__spreadValues({}, OtherBrowserFromJSONTyped(json, true)), { type: "other_browser" });
    case "safari":
      return __spreadProps(__spreadValues({}, SafariFromJSONTyped(json, true)), { type: "safari" });
    default:
      throw new Error(`No variant of Browser exists with 'type=${json["type"]}'`);
  }
}
function BrowserToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "chrome":
      return ChromeToJSON(value);
    case "edge":
      return EdgeToJSON(value);
    case "firefox":
      return FirefoxToJSON(value);
    case "internet_explorer":
      return InternetExplorerToJSON(value);
    case "opera":
      return OperaToJSON(value);
    case "other_browser":
      return OtherBrowserToJSON(value);
    case "safari":
      return SafariToJSON(value);
    default:
      throw new Error(`No variant of Browser exists with 'type=${value["type"]}'`);
  }
}

// src/models/CancelBookingFailed.ts
function instanceOfCancelBookingFailed(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function CancelBookingFailedFromJSON(json) {
  return CancelBookingFailedFromJSONTyped(json, false);
}
function CancelBookingFailedFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function CancelBookingFailedToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/CfarBookingCanceledRequest.ts
function instanceOfCfarBookingCanceledRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "booking_canceled_date_time" in value;
  return isInstance;
}
function CfarBookingCanceledRequestFromJSON(json) {
  return CfarBookingCanceledRequestFromJSONTyped(json, false);
}
function CfarBookingCanceledRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "booking_canceled_date_time": new Date(json["booking_canceled_date_time"])
  };
}
function CfarBookingCanceledRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "booking_canceled_date_time": value.booking_canceled_date_time.toISOString()
  };
}

// src/models/CfarExercise.ts
function instanceOfCfarExercise(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "contract_id" in value;
  isInstance = isInstance && "initiated_date_time" in value;
  return isInstance;
}
function CfarExerciseFromJSON(json) {
  return CfarExerciseFromJSONTyped(json, false);
}
function CfarExerciseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "contract_id": json["contract_id"],
    "initiated_date_time": new Date(json["initiated_date_time"]),
    "completed_date_time": !exists(json, "completed_date_time") ? void 0 : new Date(json["completed_date_time"]),
    "booking_canceled_date_time": !exists(json, "booking_canceled_date_time") ? void 0 : new Date(json["booking_canceled_date_time"]),
    "exchange_rate": !exists(json, "exchange_rate") ? void 0 : json["exchange_rate"],
    "partner_refund_share": !exists(json, "partner_refund_share") ? void 0 : json["partner_refund_share"],
    "airline_refund_share": !exists(json, "airline_refund_share") ? void 0 : json["airline_refund_share"],
    "currency": !exists(json, "currency") ? void 0 : json["currency"],
    "ext_attributes": !exists(json, "ext_attributes") ? void 0 : json["ext_attributes"]
  };
}
function CfarExerciseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "contract_id": value.contract_id,
    "initiated_date_time": value.initiated_date_time.toISOString(),
    "completed_date_time": value.completed_date_time === void 0 ? void 0 : value.completed_date_time.toISOString(),
    "booking_canceled_date_time": value.booking_canceled_date_time === void 0 ? void 0 : value.booking_canceled_date_time.toISOString(),
    "exchange_rate": value.exchange_rate,
    "partner_refund_share": value.partner_refund_share,
    "airline_refund_share": value.airline_refund_share,
    "currency": value.currency,
    "ext_attributes": value.ext_attributes
  };
}

// src/models/FareClass.ts
var FareClass = {
  BasicEconomy: "basic_economy",
  Economy: "economy",
  PremiumEconomy: "premium_economy",
  Business: "business",
  First: "first"
};
function FareClassFromJSON(json) {
  return FareClassFromJSONTyped(json, false);
}
function FareClassFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function FareClassToJSON(value) {
  return value;
}

// src/models/CfarFareSliceSegment.ts
function instanceOfCfarFareSliceSegment(value) {
  let isInstance = true;
  isInstance = isInstance && "origin_airport" in value;
  isInstance = isInstance && "destination_airport" in value;
  isInstance = isInstance && "departure_date_time" in value;
  isInstance = isInstance && "arrival_date_time" in value;
  isInstance = isInstance && "flight_number" in value;
  isInstance = isInstance && "validating_carrier_code" in value;
  isInstance = isInstance && "operating_carrier_code" in value;
  isInstance = isInstance && "marketing_carrier_code" in value;
  isInstance = isInstance && "fare_class" in value;
  isInstance = isInstance && "fare_basis" in value;
  return isInstance;
}
function CfarFareSliceSegmentFromJSON(json) {
  return CfarFareSliceSegmentFromJSONTyped(json, false);
}
function CfarFareSliceSegmentFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "origin_airport": json["origin_airport"],
    "destination_airport": json["destination_airport"],
    "departure_date_time": json["departure_date_time"],
    "arrival_date_time": json["arrival_date_time"],
    "flight_number": json["flight_number"],
    "validating_carrier_code": json["validating_carrier_code"],
    "operating_carrier_code": json["operating_carrier_code"],
    "marketing_carrier_code": json["marketing_carrier_code"],
    "fare_class": FareClassFromJSON(json["fare_class"]),
    "fare_basis": json["fare_basis"]
  };
}
function CfarFareSliceSegmentToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "origin_airport": value.origin_airport,
    "destination_airport": value.destination_airport,
    "departure_date_time": value.departure_date_time,
    "arrival_date_time": value.arrival_date_time,
    "flight_number": value.flight_number,
    "validating_carrier_code": value.validating_carrier_code,
    "operating_carrier_code": value.operating_carrier_code,
    "marketing_carrier_code": value.marketing_carrier_code,
    "fare_class": FareClassToJSON(value.fare_class),
    "fare_basis": value.fare_basis
  };
}

// src/models/CfarFareSlice.ts
function instanceOfCfarFareSlice(value) {
  let isInstance = true;
  isInstance = isInstance && "segments" in value;
  return isInstance;
}
function CfarFareSliceFromJSON(json) {
  return CfarFareSliceFromJSONTyped(json, false);
}
function CfarFareSliceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "segments": json["segments"].map(CfarFareSliceSegmentFromJSON)
  };
}
function CfarFareSliceToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "segments": value.segments.map(CfarFareSliceSegmentToJSON)
  };
}

// src/models/PassengerType.ts
var PassengerType = {
  Adult: "adult",
  Child: "child",
  SeatedInfant: "seated_infant",
  LapInfant: "lap_infant",
  Unknown: "unknown"
};
function PassengerTypeFromJSON(json) {
  return PassengerTypeFromJSONTyped(json, false);
}
function PassengerTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function PassengerTypeToJSON(value) {
  return value;
}

// src/models/Passenger.ts
function instanceOfPassenger(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "individual_price" in value;
  return isInstance;
}
function PassengerFromJSON(json) {
  return PassengerFromJSONTyped(json, false);
}
function PassengerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": PassengerTypeFromJSON(json["type"]),
    "name": !exists(json, "name") ? void 0 : json["name"],
    "individual_price": json["individual_price"]
  };
}
function PassengerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": PassengerTypeToJSON(value.type),
    "name": value.name,
    "individual_price": value.individual_price
  };
}

// src/models/CfarFare.ts
function instanceOfCfarFare(value) {
  let isInstance = true;
  isInstance = isInstance && "passengers" in value;
  isInstance = isInstance && "currency" in value;
  isInstance = isInstance && "slices" in value;
  return isInstance;
}
function CfarFareFromJSON(json) {
  return CfarFareFromJSONTyped(json, false);
}
function CfarFareFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "passengers": json["passengers"].map(PassengerFromJSON),
    "currency": json["currency"],
    "slices": json["slices"].map(CfarFareSliceFromJSON),
    "ancillaries": !exists(json, "ancillaries") ? void 0 : json["ancillaries"].map(AncillaryFromJSON)
  };
}
function CfarFareToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "passengers": value.passengers.map(PassengerToJSON),
    "currency": value.currency,
    "slices": value.slices.map(CfarFareSliceToJSON),
    "ancillaries": value.ancillaries === void 0 ? void 0 : value.ancillaries.map(AncillaryToJSON)
  };
}

// src/models/CfarPurchaseOption.ts
function instanceOfCfarPurchaseOption(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "premium_percentage" in value;
  isInstance = isInstance && "premium_per_passenger" in value;
  isInstance = isInstance && "total_premium" in value;
  isInstance = isInstance && "coverage_percentage" in value;
  isInstance = isInstance && "coverage_per_passenger" in value;
  isInstance = isInstance && "total_coverage" in value;
  return isInstance;
}
function CfarPurchaseOptionFromJSON(json) {
  return CfarPurchaseOptionFromJSONTyped(json, false);
}
function CfarPurchaseOptionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "premium_percentage": json["premium_percentage"],
    "premium_per_passenger": json["premium_per_passenger"],
    "total_premium": json["total_premium"],
    "coverage_percentage": json["coverage_percentage"],
    "coverage_per_passenger": json["coverage_per_passenger"],
    "total_coverage": json["total_coverage"]
  };
}
function CfarPurchaseOptionToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "premium_percentage": value.premium_percentage,
    "premium_per_passenger": value.premium_per_passenger,
    "total_premium": value.total_premium,
    "coverage_percentage": value.coverage_percentage,
    "coverage_per_passenger": value.coverage_per_passenger,
    "total_coverage": value.total_coverage
  };
}

// src/models/CfarOffer.ts
function instanceOfCfarOffer(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "purchase_options" in value;
  isInstance = isInstance && "fare" in value;
  isInstance = isInstance && "currency" in value;
  isInstance = isInstance && "to_usd_exchange_rate" in value;
  isInstance = isInstance && "contract_expiry" in value;
  isInstance = isInstance && "created_date_time" in value;
  isInstance = isInstance && "locale" in value;
  return isInstance;
}
function CfarOfferFromJSON(json) {
  return CfarOfferFromJSONTyped(json, false);
}
function CfarOfferFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "purchase_options": json["purchase_options"].map(CfarPurchaseOptionFromJSON),
    "fare": CfarFareFromJSON(json["fare"]),
    "currency": json["currency"],
    "to_usd_exchange_rate": json["to_usd_exchange_rate"],
    "contract_expiry": new Date(json["contract_expiry"]),
    "created_date_time": new Date(json["created_date_time"]),
    "ext_attributes": !exists(json, "ext_attributes") ? void 0 : json["ext_attributes"],
    "locale": json["locale"]
  };
}
function CfarOfferToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "purchase_options": value.purchase_options.map(CfarPurchaseOptionToJSON),
    "fare": CfarFareToJSON(value.fare),
    "currency": value.currency,
    "to_usd_exchange_rate": value.to_usd_exchange_rate,
    "contract_expiry": value.contract_expiry.toISOString(),
    "created_date_time": value.created_date_time.toISOString(),
    "ext_attributes": value.ext_attributes,
    "locale": value.locale
  };
}

// src/models/CfarPurchaseQuote.ts
function instanceOfCfarPurchaseQuote(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "purchase_option_id" in value;
  isInstance = isInstance && "offer" in value;
  isInstance = isInstance && "premium_per_passenger" in value;
  isInstance = isInstance && "total_premium" in value;
  isInstance = isInstance && "coverage_per_passenger" in value;
  isInstance = isInstance && "total_coverage" in value;
  isInstance = isInstance && "fare" in value;
  return isInstance;
}
function CfarPurchaseQuoteFromJSON(json) {
  return CfarPurchaseQuoteFromJSONTyped(json, false);
}
function CfarPurchaseQuoteFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "purchase_option_id": json["purchase_option_id"],
    "offer": CfarOfferFromJSON(json["offer"]),
    "premium_per_passenger": json["premium_per_passenger"],
    "total_premium": json["total_premium"],
    "coverage_per_passenger": json["coverage_per_passenger"],
    "total_coverage": json["total_coverage"],
    "fare": CfarFareFromJSON(json["fare"])
  };
}
function CfarPurchaseQuoteToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "purchase_option_id": value.purchase_option_id,
    "offer": CfarOfferToJSON(value.offer),
    "premium_per_passenger": value.premium_per_passenger,
    "total_premium": value.total_premium,
    "coverage_per_passenger": value.coverage_per_passenger,
    "total_coverage": value.total_coverage,
    "fare": CfarFareToJSON(value.fare)
  };
}

// src/models/Other.ts
function instanceOfOther(value) {
  let isInstance = true;
  isInstance = isInstance && "description" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function OtherFromJSON(json) {
  return OtherFromJSONTyped(json, false);
}
function OtherFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "description": json["description"],
    "type": json["type"]
  };
}
function OtherToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "description": value.description,
    "type": value.type
  };
}

// src/models/TicketingFailure.ts
function instanceOfTicketingFailure(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function TicketingFailureFromJSON(json) {
  return TicketingFailureFromJSONTyped(json, false);
}
function TicketingFailureFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"]
  };
}
function TicketingFailureToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// src/models/VoidWindow.ts
function instanceOfVoidWindow(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function VoidWindowFromJSON(json) {
  return VoidWindowFromJSONTyped(json, false);
}
function VoidWindowFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"]
  };
}
function VoidWindowToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// src/models/CfarRefundReason.ts
function CfarRefundReasonFromJSON(json) {
  return CfarRefundReasonFromJSONTyped(json, false);
}
function CfarRefundReasonFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "other":
      return __spreadProps(__spreadValues({}, OtherFromJSONTyped(json, true)), { type: "other" });
    case "ticketing_failure":
      return __spreadProps(__spreadValues({}, TicketingFailureFromJSONTyped(json, true)), { type: "ticketing_failure" });
    case "void_window":
      return __spreadProps(__spreadValues({}, VoidWindowFromJSONTyped(json, true)), { type: "void_window" });
    default:
      throw new Error(`No variant of CfarRefundReason exists with 'type=${json["type"]}'`);
  }
}
function CfarRefundReasonToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "other":
      return OtherToJSON(value);
    case "ticketing_failure":
      return TicketingFailureToJSON(value);
    case "void_window":
      return VoidWindowToJSON(value);
    default:
      throw new Error(`No variant of CfarRefundReason exists with 'type=${value["type"]}'`);
  }
}

// src/models/CfarRefund.ts
function instanceOfCfarRefund(value) {
  let isInstance = true;
  isInstance = isInstance && "reason" in value;
  isInstance = isInstance && "refunded_date_time" in value;
  return isInstance;
}
function CfarRefundFromJSON(json) {
  return CfarRefundFromJSONTyped(json, false);
}
function CfarRefundFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "reason": CfarRefundReasonFromJSON(json["reason"]),
    "refunded_date_time": new Date(json["refunded_date_time"])
  };
}
function CfarRefundToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "reason": CfarRefundReasonToJSON(value.reason),
    "refunded_date_time": value.refunded_date_time.toISOString()
  };
}

// src/models/State.ts
var State = {
  Active: "active",
  ExerciseFailed: "exercise_failed",
  ExerciseInitiated: "exercise_initiated",
  ExerciseProcessing: "exercise_processing",
  Exercised: "exercised",
  Expired: "expired",
  Refunded: "refunded"
};
function StateFromJSON(json) {
  return StateFromJSONTyped(json, false);
}
function StateFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function StateToJSON(value) {
  return value;
}

// src/models/CfarContract.ts
function instanceOfCfarContract(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "state" in value;
  isInstance = isInstance && "purchase_quote" in value;
  isInstance = isInstance && "partner_booking_id" in value;
  isInstance = isInstance && "booking_locators" in value;
  isInstance = isInstance && "created_date_time" in value;
  return isInstance;
}
function CfarContractFromJSON(json) {
  return CfarContractFromJSONTyped(json, false);
}
function CfarContractFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "state": StateFromJSON(json["state"]),
    "purchase_quote": CfarPurchaseQuoteFromJSON(json["purchase_quote"]),
    "partner_booking_id": json["partner_booking_id"],
    "booking_locators": json["booking_locators"],
    "created_date_time": new Date(json["created_date_time"]),
    "exercise": !exists(json, "exercise") ? void 0 : CfarExerciseFromJSON(json["exercise"]),
    "exercise_url": !exists(json, "exercise_url") ? void 0 : json["exercise_url"],
    "ext_attributes": !exists(json, "ext_attributes") ? void 0 : json["ext_attributes"],
    "refund": !exists(json, "refund") ? void 0 : CfarRefundFromJSON(json["refund"])
  };
}
function CfarContractToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "state": StateToJSON(value.state),
    "purchase_quote": CfarPurchaseQuoteToJSON(value.purchase_quote),
    "partner_booking_id": value.partner_booking_id,
    "booking_locators": value.booking_locators,
    "created_date_time": value.created_date_time.toISOString(),
    "exercise": CfarExerciseToJSON(value.exercise),
    "exercise_url": value.exercise_url,
    "ext_attributes": value.ext_attributes,
    "refund": CfarRefundToJSON(value.refund)
  };
}

// src/models/CfarEnterAuthenticatePage.ts
function instanceOfCfarEnterAuthenticatePage(value) {
  let isInstance = true;
  isInstance = isInstance && "session_id" in value;
  isInstance = isInstance && "occurred_date_time" in value;
  isInstance = isInstance && "contract_id" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function CfarEnterAuthenticatePageFromJSON(json) {
  return CfarEnterAuthenticatePageFromJSONTyped(json, false);
}
function CfarEnterAuthenticatePageFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "session_id": json["session_id"],
    "occurred_date_time": new Date(json["occurred_date_time"]),
    "contract_id": json["contract_id"],
    "type": json["type"]
  };
}
function CfarEnterAuthenticatePageToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "session_id": value.session_id,
    "occurred_date_time": value.occurred_date_time.toISOString(),
    "contract_id": value.contract_id,
    "type": value.type
  };
}

// src/models/CfarEnterCompletePage.ts
function instanceOfCfarEnterCompletePage(value) {
  let isInstance = true;
  isInstance = isInstance && "session_id" in value;
  isInstance = isInstance && "occurred_date_time" in value;
  isInstance = isInstance && "contract_id" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function CfarEnterCompletePageFromJSON(json) {
  return CfarEnterCompletePageFromJSONTyped(json, false);
}
function CfarEnterCompletePageFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "session_id": json["session_id"],
    "occurred_date_time": new Date(json["occurred_date_time"]),
    "contract_id": json["contract_id"],
    "type": json["type"]
  };
}
function CfarEnterCompletePageToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "session_id": value.session_id,
    "occurred_date_time": value.occurred_date_time.toISOString(),
    "contract_id": value.contract_id,
    "type": value.type
  };
}

// src/models/CfarEnterContractPage.ts
function instanceOfCfarEnterContractPage(value) {
  let isInstance = true;
  isInstance = isInstance && "session_id" in value;
  isInstance = isInstance && "occurred_date_time" in value;
  isInstance = isInstance && "contract_id" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function CfarEnterContractPageFromJSON(json) {
  return CfarEnterContractPageFromJSONTyped(json, false);
}
function CfarEnterContractPageFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "session_id": json["session_id"],
    "occurred_date_time": new Date(json["occurred_date_time"]),
    "contract_id": json["contract_id"],
    "type": json["type"]
  };
}
function CfarEnterContractPageToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "session_id": value.session_id,
    "occurred_date_time": value.occurred_date_time.toISOString(),
    "contract_id": value.contract_id,
    "type": value.type
  };
}

// src/models/CfarEnterLandingPage.ts
function instanceOfCfarEnterLandingPage(value) {
  let isInstance = true;
  isInstance = isInstance && "session_id" in value;
  isInstance = isInstance && "occurred_date_time" in value;
  isInstance = isInstance && "contract_id" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function CfarEnterLandingPageFromJSON(json) {
  return CfarEnterLandingPageFromJSONTyped(json, false);
}
function CfarEnterLandingPageFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "session_id": json["session_id"],
    "occurred_date_time": new Date(json["occurred_date_time"]),
    "contract_id": json["contract_id"],
    "type": json["type"]
  };
}
function CfarEnterLandingPageToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "session_id": value.session_id,
    "occurred_date_time": value.occurred_date_time.toISOString(),
    "contract_id": value.contract_id,
    "type": value.type
  };
}

// src/models/CfarEnterPaymentErrorPage.ts
function instanceOfCfarEnterPaymentErrorPage(value) {
  let isInstance = true;
  isInstance = isInstance && "session_id" in value;
  isInstance = isInstance && "occurred_date_time" in value;
  isInstance = isInstance && "contract_id" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function CfarEnterPaymentErrorPageFromJSON(json) {
  return CfarEnterPaymentErrorPageFromJSONTyped(json, false);
}
function CfarEnterPaymentErrorPageFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "session_id": json["session_id"],
    "occurred_date_time": new Date(json["occurred_date_time"]),
    "contract_id": json["contract_id"],
    "type": json["type"]
  };
}
function CfarEnterPaymentErrorPageToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "session_id": value.session_id,
    "occurred_date_time": value.occurred_date_time.toISOString(),
    "contract_id": value.contract_id,
    "type": value.type
  };
}

// src/models/CfarEnterRegisterPage.ts
function instanceOfCfarEnterRegisterPage(value) {
  let isInstance = true;
  isInstance = isInstance && "session_id" in value;
  isInstance = isInstance && "occurred_date_time" in value;
  isInstance = isInstance && "contract_id" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function CfarEnterRegisterPageFromJSON(json) {
  return CfarEnterRegisterPageFromJSONTyped(json, false);
}
function CfarEnterRegisterPageFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "session_id": json["session_id"],
    "occurred_date_time": new Date(json["occurred_date_time"]),
    "contract_id": json["contract_id"],
    "type": json["type"]
  };
}
function CfarEnterRegisterPageToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "session_id": value.session_id,
    "occurred_date_time": value.occurred_date_time.toISOString(),
    "contract_id": value.contract_id,
    "type": value.type
  };
}

// src/models/CfarEnterTransferMethodPage.ts
function instanceOfCfarEnterTransferMethodPage(value) {
  let isInstance = true;
  isInstance = isInstance && "session_id" in value;
  isInstance = isInstance && "occurred_date_time" in value;
  isInstance = isInstance && "contract_id" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function CfarEnterTransferMethodPageFromJSON(json) {
  return CfarEnterTransferMethodPageFromJSONTyped(json, false);
}
function CfarEnterTransferMethodPageFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "session_id": json["session_id"],
    "occurred_date_time": new Date(json["occurred_date_time"]),
    "contract_id": json["contract_id"],
    "type": json["type"]
  };
}
function CfarEnterTransferMethodPageToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "session_id": value.session_id,
    "occurred_date_time": value.occurred_date_time.toISOString(),
    "contract_id": value.contract_id,
    "type": value.type
  };
}

// src/models/CfarEnterVerificationPage.ts
function instanceOfCfarEnterVerificationPage(value) {
  let isInstance = true;
  isInstance = isInstance && "session_id" in value;
  isInstance = isInstance && "occurred_date_time" in value;
  isInstance = isInstance && "contract_id" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function CfarEnterVerificationPageFromJSON(json) {
  return CfarEnterVerificationPageFromJSONTyped(json, false);
}
function CfarEnterVerificationPageFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "session_id": json["session_id"],
    "occurred_date_time": new Date(json["occurred_date_time"]),
    "contract_id": json["contract_id"],
    "type": json["type"]
  };
}
function CfarEnterVerificationPageToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "session_id": value.session_id,
    "occurred_date_time": value.occurred_date_time.toISOString(),
    "contract_id": value.contract_id,
    "type": value.type
  };
}

// src/models/CfarOfferShown.ts
function instanceOfCfarOfferShown(value) {
  let isInstance = true;
  isInstance = isInstance && "session_id" in value;
  isInstance = isInstance && "occurred_date_time" in value;
  isInstance = isInstance && "offer_id" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function CfarOfferShownFromJSON(json) {
  return CfarOfferShownFromJSONTyped(json, false);
}
function CfarOfferShownFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "session_id": json["session_id"],
    "occurred_date_time": new Date(json["occurred_date_time"]),
    "offer_id": json["offer_id"],
    "type": json["type"]
  };
}
function CfarOfferShownToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "session_id": value.session_id,
    "occurred_date_time": value.occurred_date_time.toISOString(),
    "offer_id": value.offer_id,
    "type": value.type
  };
}

// src/models/CfarRefundRequest.ts
function instanceOfCfarRefundRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "refunded_date_time" in value;
  isInstance = isInstance && "reason" in value;
  return isInstance;
}
function CfarRefundRequestFromJSON(json) {
  return CfarRefundRequestFromJSONTyped(json, false);
}
function CfarRefundRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "refunded_date_time": new Date(json["refunded_date_time"]),
    "reason": CfarRefundReasonFromJSON(json["reason"])
  };
}
function CfarRefundRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "refunded_date_time": value.refunded_date_time.toISOString(),
    "reason": CfarRefundReasonToJSON(value.reason)
  };
}

// src/models/ContractNotFound1.ts
function instanceOfContractNotFound1(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function ContractNotFound1FromJSON(json) {
  return ContractNotFound1FromJSONTyped(json, false);
}
function ContractNotFound1FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function ContractNotFound1ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/ContractStateInvalid.ts
function instanceOfContractStateInvalid(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function ContractStateInvalidFromJSON(json) {
  return ContractStateInvalidFromJSONTyped(json, false);
}
function ContractStateInvalidFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function ContractStateInvalidToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/EmailFailure.ts
function instanceOfEmailFailure(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function EmailFailureFromJSON(json) {
  return EmailFailureFromJSONTyped(json, false);
}
function EmailFailureFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function EmailFailureToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/ExerciseAlreadyCompleted.ts
function instanceOfExerciseAlreadyCompleted(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function ExerciseAlreadyCompletedFromJSON(json) {
  return ExerciseAlreadyCompletedFromJSONTyped(json, false);
}
function ExerciseAlreadyCompletedFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function ExerciseAlreadyCompletedToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/ExerciseNotFound.ts
function instanceOfExerciseNotFound(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function ExerciseNotFoundFromJSON(json) {
  return ExerciseNotFoundFromJSONTyped(json, false);
}
function ExerciseNotFoundFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function ExerciseNotFoundToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/InvalidAirportCode.ts
function instanceOfInvalidAirportCode(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function InvalidAirportCodeFromJSON(json) {
  return InvalidAirportCodeFromJSONTyped(json, false);
}
function InvalidAirportCodeFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function InvalidAirportCodeToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/InvalidCompletedDateTime.ts
function instanceOfInvalidCompletedDateTime(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function InvalidCompletedDateTimeFromJSON(json) {
  return InvalidCompletedDateTimeFromJSONTyped(json, false);
}
function InvalidCompletedDateTimeFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function InvalidCompletedDateTimeToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/InvalidCurrency.ts
function instanceOfInvalidCurrency(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function InvalidCurrencyFromJSON(json) {
  return InvalidCurrencyFromJSONTyped(json, false);
}
function InvalidCurrencyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function InvalidCurrencyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/InvalidFarePrice.ts
function instanceOfInvalidFarePrice(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function InvalidFarePriceFromJSON(json) {
  return InvalidFarePriceFromJSONTyped(json, false);
}
function InvalidFarePriceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function InvalidFarePriceToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/InvalidFareSlices.ts
function instanceOfInvalidFareSlices(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function InvalidFareSlicesFromJSON(json) {
  return InvalidFareSlicesFromJSONTyped(json, false);
}
function InvalidFareSlicesFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function InvalidFareSlicesToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/InvalidInitiatedDateTime.ts
function instanceOfInvalidInitiatedDateTime(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function InvalidInitiatedDateTimeFromJSON(json) {
  return InvalidInitiatedDateTimeFromJSONTyped(json, false);
}
function InvalidInitiatedDateTimeFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function InvalidInitiatedDateTimeToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/InvalidLocale.ts
function instanceOfInvalidLocale(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function InvalidLocaleFromJSON(json) {
  return InvalidLocaleFromJSONTyped(json, false);
}
function InvalidLocaleFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function InvalidLocaleToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/InvalidPassengerCounts.ts
function instanceOfInvalidPassengerCounts(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function InvalidPassengerCountsFromJSON(json) {
  return InvalidPassengerCountsFromJSONTyped(json, false);
}
function InvalidPassengerCountsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function InvalidPassengerCountsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/InvalidRefund.ts
function instanceOfInvalidRefund(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function InvalidRefundFromJSON(json) {
  return InvalidRefundFromJSONTyped(json, false);
}
function InvalidRefundFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function InvalidRefundToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/InvalidState.ts
function instanceOfInvalidState(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function InvalidStateFromJSON(json) {
  return InvalidStateFromJSONTyped(json, false);
}
function InvalidStateFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function InvalidStateToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/OfferExpired.ts
function instanceOfOfferExpired(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function OfferExpiredFromJSON(json) {
  return OfferExpiredFromJSONTyped(json, false);
}
function OfferExpiredFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function OfferExpiredToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/OfferNotCreated.ts
function instanceOfOfferNotCreated(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function OfferNotCreatedFromJSON(json) {
  return OfferNotCreatedFromJSONTyped(json, false);
}
function OfferNotCreatedFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function OfferNotCreatedToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/OfferNotFound1.ts
function instanceOfOfferNotFound1(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function OfferNotFound1FromJSON(json) {
  return OfferNotFound1FromJSONTyped(json, false);
}
function OfferNotFound1FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function OfferNotFound1ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/PartnerUserNotFound.ts
function instanceOfPartnerUserNotFound(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function PartnerUserNotFoundFromJSON(json) {
  return PartnerUserNotFoundFromJSONTyped(json, false);
}
function PartnerUserNotFoundFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function PartnerUserNotFoundToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/PurchaseOptionNotFound.ts
function instanceOfPurchaseOptionNotFound(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function PurchaseOptionNotFoundFromJSON(json) {
  return PurchaseOptionNotFoundFromJSONTyped(json, false);
}
function PurchaseOptionNotFoundFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function PurchaseOptionNotFoundToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/PurchaseQuoteAlreadyPurchased.ts
function instanceOfPurchaseQuoteAlreadyPurchased(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function PurchaseQuoteAlreadyPurchasedFromJSON(json) {
  return PurchaseQuoteAlreadyPurchasedFromJSONTyped(json, false);
}
function PurchaseQuoteAlreadyPurchasedFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function PurchaseQuoteAlreadyPurchasedToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/PurchaseQuoteNotFound.ts
function instanceOfPurchaseQuoteNotFound(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function PurchaseQuoteNotFoundFromJSON(json) {
  return PurchaseQuoteNotFoundFromJSONTyped(json, false);
}
function PurchaseQuoteNotFoundFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function PurchaseQuoteNotFoundToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/SessionIdOrCreateSessionRequestRequired.ts
function instanceOfSessionIdOrCreateSessionRequestRequired(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function SessionIdOrCreateSessionRequestRequiredFromJSON(json) {
  return SessionIdOrCreateSessionRequestRequiredFromJSONTyped(json, false);
}
function SessionIdOrCreateSessionRequestRequiredFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function SessionIdOrCreateSessionRequestRequiredToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/ClientError.ts
function ClientErrorFromJSON(json) {
  return ClientErrorFromJSONTyped(json, false);
}
function ClientErrorFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["code"]) {
    case "cancel_booking_failed":
      return __spreadProps(__spreadValues({}, CancelBookingFailedFromJSONTyped(json, true)), { code: "cancel_booking_failed" });
    case "contract_not_found":
      return __spreadProps(__spreadValues({}, ContractNotFound1FromJSONTyped(json, true)), { code: "contract_not_found" });
    case "contract_state_invalid":
      return __spreadProps(__spreadValues({}, ContractStateInvalidFromJSONTyped(json, true)), { code: "contract_state_invalid" });
    case "email_failure":
      return __spreadProps(__spreadValues({}, EmailFailureFromJSONTyped(json, true)), { code: "email_failure" });
    case "exercise_already_completed":
      return __spreadProps(__spreadValues({}, ExerciseAlreadyCompletedFromJSONTyped(json, true)), { code: "exercise_already_completed" });
    case "exercise_not_found":
      return __spreadProps(__spreadValues({}, ExerciseNotFoundFromJSONTyped(json, true)), { code: "exercise_not_found" });
    case "invalid_airport_code":
      return __spreadProps(__spreadValues({}, InvalidAirportCodeFromJSONTyped(json, true)), { code: "invalid_airport_code" });
    case "invalid_completed_date_time":
      return __spreadProps(__spreadValues({}, InvalidCompletedDateTimeFromJSONTyped(json, true)), { code: "invalid_completed_date_time" });
    case "invalid_currency":
      return __spreadProps(__spreadValues({}, InvalidCurrencyFromJSONTyped(json, true)), { code: "invalid_currency" });
    case "invalid_fare_price":
      return __spreadProps(__spreadValues({}, InvalidFarePriceFromJSONTyped(json, true)), { code: "invalid_fare_price" });
    case "invalid_fare_slices":
      return __spreadProps(__spreadValues({}, InvalidFareSlicesFromJSONTyped(json, true)), { code: "invalid_fare_slices" });
    case "invalid_initiated_date_time":
      return __spreadProps(__spreadValues({}, InvalidInitiatedDateTimeFromJSONTyped(json, true)), { code: "invalid_initiated_date_time" });
    case "invalid_locale":
      return __spreadProps(__spreadValues({}, InvalidLocaleFromJSONTyped(json, true)), { code: "invalid_locale" });
    case "invalid_passenger_counts":
      return __spreadProps(__spreadValues({}, InvalidPassengerCountsFromJSONTyped(json, true)), { code: "invalid_passenger_counts" });
    case "invalid_refund":
      return __spreadProps(__spreadValues({}, InvalidRefundFromJSONTyped(json, true)), { code: "invalid_refund" });
    case "invalid_state":
      return __spreadProps(__spreadValues({}, InvalidStateFromJSONTyped(json, true)), { code: "invalid_state" });
    case "offer_expired":
      return __spreadProps(__spreadValues({}, OfferExpiredFromJSONTyped(json, true)), { code: "offer_expired" });
    case "offer_not_created":
      return __spreadProps(__spreadValues({}, OfferNotCreatedFromJSONTyped(json, true)), { code: "offer_not_created" });
    case "offer_not_found":
      return __spreadProps(__spreadValues({}, OfferNotFound1FromJSONTyped(json, true)), { code: "offer_not_found" });
    case "partner_user_not_found":
      return __spreadProps(__spreadValues({}, PartnerUserNotFoundFromJSONTyped(json, true)), { code: "partner_user_not_found" });
    case "purchase_option_not_found":
      return __spreadProps(__spreadValues({}, PurchaseOptionNotFoundFromJSONTyped(json, true)), { code: "purchase_option_not_found" });
    case "purchase_quote_already_purchased":
      return __spreadProps(__spreadValues({}, PurchaseQuoteAlreadyPurchasedFromJSONTyped(json, true)), { code: "purchase_quote_already_purchased" });
    case "purchase_quote_not_found":
      return __spreadProps(__spreadValues({}, PurchaseQuoteNotFoundFromJSONTyped(json, true)), { code: "purchase_quote_not_found" });
    case "session_id_or_create_session_request_required":
      return __spreadProps(__spreadValues({}, SessionIdOrCreateSessionRequestRequiredFromJSONTyped(json, true)), { code: "session_id_or_create_session_request_required" });
    default:
      throw new Error(`No variant of ClientError exists with 'code=${json["code"]}'`);
  }
}
function ClientErrorToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["code"]) {
    case "cancel_booking_failed":
      return CancelBookingFailedToJSON(value);
    case "contract_not_found":
      return ContractNotFound1ToJSON(value);
    case "contract_state_invalid":
      return ContractStateInvalidToJSON(value);
    case "email_failure":
      return EmailFailureToJSON(value);
    case "exercise_already_completed":
      return ExerciseAlreadyCompletedToJSON(value);
    case "exercise_not_found":
      return ExerciseNotFoundToJSON(value);
    case "invalid_airport_code":
      return InvalidAirportCodeToJSON(value);
    case "invalid_completed_date_time":
      return InvalidCompletedDateTimeToJSON(value);
    case "invalid_currency":
      return InvalidCurrencyToJSON(value);
    case "invalid_fare_price":
      return InvalidFarePriceToJSON(value);
    case "invalid_fare_slices":
      return InvalidFareSlicesToJSON(value);
    case "invalid_initiated_date_time":
      return InvalidInitiatedDateTimeToJSON(value);
    case "invalid_locale":
      return InvalidLocaleToJSON(value);
    case "invalid_passenger_counts":
      return InvalidPassengerCountsToJSON(value);
    case "invalid_refund":
      return InvalidRefundToJSON(value);
    case "invalid_state":
      return InvalidStateToJSON(value);
    case "offer_expired":
      return OfferExpiredToJSON(value);
    case "offer_not_created":
      return OfferNotCreatedToJSON(value);
    case "offer_not_found":
      return OfferNotFound1ToJSON(value);
    case "partner_user_not_found":
      return PartnerUserNotFoundToJSON(value);
    case "purchase_option_not_found":
      return PurchaseOptionNotFoundToJSON(value);
    case "purchase_quote_already_purchased":
      return PurchaseQuoteAlreadyPurchasedToJSON(value);
    case "purchase_quote_not_found":
      return PurchaseQuoteNotFoundToJSON(value);
    case "session_id_or_create_session_request_required":
      return SessionIdOrCreateSessionRequestRequiredToJSON(value);
    default:
      throw new Error(`No variant of ClientError exists with 'code=${value["code"]}'`);
  }
}

// src/models/CompleteCfarExerciseRequest.ts
function instanceOfCompleteCfarExerciseRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "completed_date_time" in value;
  isInstance = isInstance && "booking_canceled_date_time" in value;
  isInstance = isInstance && "partner_refund_share" in value;
  isInstance = isInstance && "airline_refund_share" in value;
  return isInstance;
}
function CompleteCfarExerciseRequestFromJSON(json) {
  return CompleteCfarExerciseRequestFromJSONTyped(json, false);
}
function CompleteCfarExerciseRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "completed_date_time": new Date(json["completed_date_time"]),
    "booking_canceled_date_time": new Date(json["booking_canceled_date_time"]),
    "partner_refund_share": json["partner_refund_share"],
    "airline_refund_share": json["airline_refund_share"]
  };
}
function CompleteCfarExerciseRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "completed_date_time": value.completed_date_time.toISOString(),
    "booking_canceled_date_time": value.booking_canceled_date_time.toISOString(),
    "partner_refund_share": value.partner_refund_share,
    "airline_refund_share": value.airline_refund_share
  };
}

// src/models/CompleteExerciseClientError.ts
function CompleteExerciseClientErrorFromJSON(json) {
  return CompleteExerciseClientErrorFromJSONTyped(json, false);
}
function CompleteExerciseClientErrorFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["code"]) {
    case "exercise_already_completed":
      return __spreadProps(__spreadValues({}, ExerciseAlreadyCompletedFromJSONTyped(json, true)), { code: "exercise_already_completed" });
    case "exercise_not_found":
      return __spreadProps(__spreadValues({}, ExerciseNotFoundFromJSONTyped(json, true)), { code: "exercise_not_found" });
    case "invalid_completed_date_time":
      return __spreadProps(__spreadValues({}, InvalidCompletedDateTimeFromJSONTyped(json, true)), { code: "invalid_completed_date_time" });
    case "invalid_refund":
      return __spreadProps(__spreadValues({}, InvalidRefundFromJSONTyped(json, true)), { code: "invalid_refund" });
    case "invalid_state":
      return __spreadProps(__spreadValues({}, InvalidStateFromJSONTyped(json, true)), { code: "invalid_state" });
    default:
      throw new Error(`No variant of CompleteExerciseClientError exists with 'code=${json["code"]}'`);
  }
}
function CompleteExerciseClientErrorToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["code"]) {
    case "exercise_already_completed":
      return ExerciseAlreadyCompletedToJSON(value);
    case "exercise_not_found":
      return ExerciseNotFoundToJSON(value);
    case "invalid_completed_date_time":
      return InvalidCompletedDateTimeToJSON(value);
    case "invalid_refund":
      return InvalidRefundToJSON(value);
    case "invalid_state":
      return InvalidStateToJSON(value);
    default:
      throw new Error(`No variant of CompleteExerciseClientError exists with 'code=${value["code"]}'`);
  }
}

// src/models/PartnerUser.ts
function instanceOfPartnerUser(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "email" in value;
  return isInstance;
}
function PartnerUserFromJSON(json) {
  return PartnerUserFromJSONTyped(json, false);
}
function PartnerUserFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "email": json["email"],
    "phone_number": !exists(json, "phone_number") ? void 0 : json["phone_number"]
  };
}
function PartnerUserToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "email": value.email,
    "phone_number": value.phone_number
  };
}

// src/models/OfflineReconciliation.ts
function instanceOfOfflineReconciliation(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function OfflineReconciliationFromJSON(json) {
  return OfflineReconciliationFromJSONTyped(json, false);
}
function OfflineReconciliationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"]
  };
}
function OfflineReconciliationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// src/models/PaymentMethod.ts
function PaymentMethodFromJSON(json) {
  return PaymentMethodFromJSONTyped(json, false);
}
function PaymentMethodFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "offline_reconciliation":
      return __spreadProps(__spreadValues({}, OfflineReconciliationFromJSONTyped(json, true)), { type: "offline_reconciliation" });
    default:
      throw new Error(`No variant of PaymentMethod exists with 'type=${json["type"]}'`);
  }
}
function PaymentMethodToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "offline_reconciliation":
      return OfflineReconciliationToJSON(value);
    default:
      throw new Error(`No variant of PaymentMethod exists with 'type=${value["type"]}'`);
  }
}

// src/models/CreateCfarContractRequest.ts
function instanceOfCreateCfarContractRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "partner_user" in value;
  isInstance = isInstance && "purchase_quote_id" in value;
  isInstance = isInstance && "partner_booking_id" in value;
  isInstance = isInstance && "booking_locators" in value;
  isInstance = isInstance && "payment_method" in value;
  return isInstance;
}
function CreateCfarContractRequestFromJSON(json) {
  return CreateCfarContractRequestFromJSONTyped(json, false);
}
function CreateCfarContractRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "partner_user": PartnerUserFromJSON(json["partner_user"]),
    "purchase_quote_id": json["purchase_quote_id"],
    "partner_booking_id": json["partner_booking_id"],
    "booking_locators": json["booking_locators"],
    "payment_method": PaymentMethodFromJSON(json["payment_method"]),
    "ext_attributes": !exists(json, "ext_attributes") ? void 0 : json["ext_attributes"]
  };
}
function CreateCfarContractRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "partner_user": PartnerUserToJSON(value.partner_user),
    "purchase_quote_id": value.purchase_quote_id,
    "partner_booking_id": value.partner_booking_id,
    "booking_locators": value.booking_locators,
    "payment_method": PaymentMethodToJSON(value.payment_method),
    "ext_attributes": value.ext_attributes
  };
}

// src/models/CreateCfarExerciseRequest.ts
function instanceOfCreateCfarExerciseRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "contract_id" in value;
  isInstance = isInstance && "initiated_date_time" in value;
  return isInstance;
}
function CreateCfarExerciseRequestFromJSON(json) {
  return CreateCfarExerciseRequestFromJSONTyped(json, false);
}
function CreateCfarExerciseRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contract_id": json["contract_id"],
    "initiated_date_time": new Date(json["initiated_date_time"]),
    "ext_attributes": !exists(json, "ext_attributes") ? void 0 : json["ext_attributes"]
  };
}
function CreateCfarExerciseRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "contract_id": value.contract_id,
    "initiated_date_time": value.initiated_date_time.toISOString(),
    "ext_attributes": value.ext_attributes
  };
}

// src/models/Web.ts
function instanceOfWeb(value) {
  let isInstance = true;
  isInstance = isInstance && "operating_system" in value;
  isInstance = isInstance && "browser" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function WebFromJSON(json) {
  return WebFromJSONTyped(json, false);
}
function WebFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "operating_system": OperatingSystemFromJSON(json["operating_system"]),
    "browser": BrowserFromJSON(json["browser"]),
    "type": json["type"]
  };
}
function WebToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "operating_system": OperatingSystemToJSON(value.operating_system),
    "browser": BrowserToJSON(value.browser),
    "type": value.type
  };
}

// src/models/Platform.ts
function PlatformFromJSON(json) {
  return PlatformFromJSONTyped(json, false);
}
function PlatformFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "app":
      return __spreadProps(__spreadValues({}, AppFromJSONTyped(json, true)), { type: "app" });
    case "web":
      return __spreadProps(__spreadValues({}, WebFromJSONTyped(json, true)), { type: "web" });
    default:
      throw new Error(`No variant of Platform exists with 'type=${json["type"]}'`);
  }
}
function PlatformToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "app":
      return AppToJSON(value);
    case "web":
      return WebToJSON(value);
    default:
      throw new Error(`No variant of Platform exists with 'type=${value["type"]}'`);
  }
}

// src/models/Desktop.ts
function instanceOfDesktop(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "platform" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function DesktopFromJSON(json) {
  return DesktopFromJSONTyped(json, false);
}
function DesktopFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "platform": PlatformFromJSON(json["platform"]),
    "type": json["type"]
  };
}
function DesktopToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "platform": PlatformToJSON(value.platform),
    "type": value.type
  };
}

// src/models/Mobile.ts
function instanceOfMobile(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "platform" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function MobileFromJSON(json) {
  return MobileFromJSONTyped(json, false);
}
function MobileFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "platform": PlatformFromJSON(json["platform"]),
    "type": json["type"]
  };
}
function MobileToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "platform": PlatformToJSON(value.platform),
    "type": value.type
  };
}

// src/models/Server.ts
function instanceOfServer(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function ServerFromJSON(json) {
  return ServerFromJSONTyped(json, false);
}
function ServerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"]
  };
}
function ServerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// src/models/Tablet.ts
function instanceOfTablet(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "platform" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function TabletFromJSON(json) {
  return TabletFromJSONTyped(json, false);
}
function TabletFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "platform": PlatformFromJSON(json["platform"]),
    "type": json["type"]
  };
}
function TabletToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "platform": PlatformToJSON(value.platform),
    "type": value.type
  };
}

// src/models/Device.ts
function DeviceFromJSON(json) {
  return DeviceFromJSONTyped(json, false);
}
function DeviceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "desktop":
      return __spreadProps(__spreadValues({}, DesktopFromJSONTyped(json, true)), { type: "desktop" });
    case "mobile":
      return __spreadProps(__spreadValues({}, MobileFromJSONTyped(json, true)), { type: "mobile" });
    case "server":
      return __spreadProps(__spreadValues({}, ServerFromJSONTyped(json, true)), { type: "server" });
    case "tablet":
      return __spreadProps(__spreadValues({}, TabletFromJSONTyped(json, true)), { type: "tablet" });
    default:
      throw new Error(`No variant of Device exists with 'type=${json["type"]}'`);
  }
}
function DeviceToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "desktop":
      return DesktopToJSON(value);
    case "mobile":
      return MobileToJSON(value);
    case "server":
      return ServerToJSON(value);
    case "tablet":
      return TabletToJSON(value);
    default:
      throw new Error(`No variant of Device exists with 'type=${value["type"]}'`);
  }
}

// src/models/CreateSessionRequest.ts
function instanceOfCreateSessionRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "device" in value;
  return isInstance;
}
function CreateSessionRequestFromJSON(json) {
  return CreateSessionRequestFromJSONTyped(json, false);
}
function CreateSessionRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "partner_user_id": !exists(json, "partner_user_id") ? void 0 : json["partner_user_id"],
    "device": DeviceFromJSON(json["device"])
  };
}
function CreateSessionRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "partner_user_id": value.partner_user_id,
    "device": DeviceToJSON(value.device)
  };
}

// src/models/CreateCfarOfferRequest.ts
function instanceOfCreateCfarOfferRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "fare" in value;
  return isInstance;
}
function CreateCfarOfferRequestFromJSON(json) {
  return CreateCfarOfferRequestFromJSONTyped(json, false);
}
function CreateCfarOfferRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "fare": CfarFareFromJSON(json["fare"]),
    "entry_point": !exists(json, "entry_point") ? void 0 : json["entry_point"],
    "ext_attributes": !exists(json, "ext_attributes") ? void 0 : json["ext_attributes"],
    "locale": !exists(json, "locale") ? void 0 : json["locale"],
    "session": !exists(json, "session") ? void 0 : CreateSessionRequestFromJSON(json["session"])
  };
}
function CreateCfarOfferRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "fare": CfarFareToJSON(value.fare),
    "entry_point": value.entry_point,
    "ext_attributes": value.ext_attributes,
    "locale": value.locale,
    "session": CreateSessionRequestToJSON(value.session)
  };
}

// src/models/CreateCfarPurchaseQuoteRequest.ts
function instanceOfCreateCfarPurchaseQuoteRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "purchase_option_id" in value;
  isInstance = isInstance && "fare" in value;
  return isInstance;
}
function CreateCfarPurchaseQuoteRequestFromJSON(json) {
  return CreateCfarPurchaseQuoteRequestFromJSONTyped(json, false);
}
function CreateCfarPurchaseQuoteRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "purchase_option_id": json["purchase_option_id"],
    "fare": CfarFareFromJSON(json["fare"])
  };
}
function CreateCfarPurchaseQuoteRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "purchase_option_id": value.purchase_option_id,
    "fare": CfarFareToJSON(value.fare)
  };
}

// src/models/CreateContractClientError.ts
function CreateContractClientErrorFromJSON(json) {
  return CreateContractClientErrorFromJSONTyped(json, false);
}
function CreateContractClientErrorFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["code"]) {
    case "offer_expired":
      return __spreadProps(__spreadValues({}, OfferExpiredFromJSONTyped(json, true)), { code: "offer_expired" });
    case "purchase_quote_already_purchased":
      return __spreadProps(__spreadValues({}, PurchaseQuoteAlreadyPurchasedFromJSONTyped(json, true)), { code: "purchase_quote_already_purchased" });
    case "purchase_quote_not_found":
      return __spreadProps(__spreadValues({}, PurchaseQuoteNotFoundFromJSONTyped(json, true)), { code: "purchase_quote_not_found" });
    default:
      throw new Error(`No variant of CreateContractClientError exists with 'code=${json["code"]}'`);
  }
}
function CreateContractClientErrorToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["code"]) {
    case "offer_expired":
      return OfferExpiredToJSON(value);
    case "purchase_quote_already_purchased":
      return PurchaseQuoteAlreadyPurchasedToJSON(value);
    case "purchase_quote_not_found":
      return PurchaseQuoteNotFoundToJSON(value);
    default:
      throw new Error(`No variant of CreateContractClientError exists with 'code=${value["code"]}'`);
  }
}

// src/models/CreateDisruptionOfferRequest.ts
function instanceOfCreateDisruptionOfferRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "field" in value;
  return isInstance;
}
function CreateDisruptionOfferRequestFromJSON(json) {
  return CreateDisruptionOfferRequestFromJSONTyped(json, false);
}
function CreateDisruptionOfferRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "field": json["field"]
  };
}
function CreateDisruptionOfferRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "field": value.field
  };
}

// src/models/CreateExerciseClientError.ts
function CreateExerciseClientErrorFromJSON(json) {
  return CreateExerciseClientErrorFromJSONTyped(json, false);
}
function CreateExerciseClientErrorFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["code"]) {
    case "cancel_booking_failed":
      return __spreadProps(__spreadValues({}, CancelBookingFailedFromJSONTyped(json, true)), { code: "cancel_booking_failed" });
    case "contract_not_found":
      return __spreadProps(__spreadValues({}, ContractNotFound1FromJSONTyped(json, true)), { code: "contract_not_found" });
    case "contract_state_invalid":
      return __spreadProps(__spreadValues({}, ContractStateInvalidFromJSONTyped(json, true)), { code: "contract_state_invalid" });
    case "invalid_initiated_date_time":
      return __spreadProps(__spreadValues({}, InvalidInitiatedDateTimeFromJSONTyped(json, true)), { code: "invalid_initiated_date_time" });
    default:
      throw new Error(`No variant of CreateExerciseClientError exists with 'code=${json["code"]}'`);
  }
}
function CreateExerciseClientErrorToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["code"]) {
    case "cancel_booking_failed":
      return CancelBookingFailedToJSON(value);
    case "contract_not_found":
      return ContractNotFound1ToJSON(value);
    case "contract_state_invalid":
      return ContractStateInvalidToJSON(value);
    case "invalid_initiated_date_time":
      return InvalidInitiatedDateTimeToJSON(value);
    default:
      throw new Error(`No variant of CreateExerciseClientError exists with 'code=${value["code"]}'`);
  }
}

// src/models/CreateOfferClientError.ts
function CreateOfferClientErrorFromJSON(json) {
  return CreateOfferClientErrorFromJSONTyped(json, false);
}
function CreateOfferClientErrorFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["code"]) {
    case "invalid_airport_code":
      return __spreadProps(__spreadValues({}, InvalidAirportCodeFromJSONTyped(json, true)), { code: "invalid_airport_code" });
    case "invalid_fare_price":
      return __spreadProps(__spreadValues({}, InvalidFarePriceFromJSONTyped(json, true)), { code: "invalid_fare_price" });
    case "invalid_locale":
      return __spreadProps(__spreadValues({}, InvalidLocaleFromJSONTyped(json, true)), { code: "invalid_locale" });
    case "offer_not_created":
      return __spreadProps(__spreadValues({}, OfferNotCreatedFromJSONTyped(json, true)), { code: "offer_not_created" });
    case "session_id_or_create_session_request_required":
      return __spreadProps(__spreadValues({}, SessionIdOrCreateSessionRequestRequiredFromJSONTyped(json, true)), { code: "session_id_or_create_session_request_required" });
    default:
      throw new Error(`No variant of CreateOfferClientError exists with 'code=${json["code"]}'`);
  }
}
function CreateOfferClientErrorToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["code"]) {
    case "invalid_airport_code":
      return InvalidAirportCodeToJSON(value);
    case "invalid_fare_price":
      return InvalidFarePriceToJSON(value);
    case "invalid_locale":
      return InvalidLocaleToJSON(value);
    case "offer_not_created":
      return OfferNotCreatedToJSON(value);
    case "session_id_or_create_session_request_required":
      return SessionIdOrCreateSessionRequestRequiredToJSON(value);
    default:
      throw new Error(`No variant of CreateOfferClientError exists with 'code=${value["code"]}'`);
  }
}

// src/models/CreatePurchaseQuoteClientError.ts
function CreatePurchaseQuoteClientErrorFromJSON(json) {
  return CreatePurchaseQuoteClientErrorFromJSONTyped(json, false);
}
function CreatePurchaseQuoteClientErrorFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["code"]) {
    case "invalid_currency":
      return __spreadProps(__spreadValues({}, InvalidCurrencyFromJSONTyped(json, true)), { code: "invalid_currency" });
    case "invalid_fare_price":
      return __spreadProps(__spreadValues({}, InvalidFarePriceFromJSONTyped(json, true)), { code: "invalid_fare_price" });
    case "invalid_fare_slices":
      return __spreadProps(__spreadValues({}, InvalidFareSlicesFromJSONTyped(json, true)), { code: "invalid_fare_slices" });
    case "invalid_passenger_counts":
      return __spreadProps(__spreadValues({}, InvalidPassengerCountsFromJSONTyped(json, true)), { code: "invalid_passenger_counts" });
    case "offer_not_found":
      return __spreadProps(__spreadValues({}, OfferNotFound1FromJSONTyped(json, true)), { code: "offer_not_found" });
    case "purchase_option_not_found":
      return __spreadProps(__spreadValues({}, PurchaseOptionNotFoundFromJSONTyped(json, true)), { code: "purchase_option_not_found" });
    default:
      throw new Error(`No variant of CreatePurchaseQuoteClientError exists with 'code=${json["code"]}'`);
  }
}
function CreatePurchaseQuoteClientErrorToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["code"]) {
    case "invalid_currency":
      return InvalidCurrencyToJSON(value);
    case "invalid_fare_price":
      return InvalidFarePriceToJSON(value);
    case "invalid_fare_slices":
      return InvalidFareSlicesToJSON(value);
    case "invalid_passenger_counts":
      return InvalidPassengerCountsToJSON(value);
    case "offer_not_found":
      return OfferNotFound1ToJSON(value);
    case "purchase_option_not_found":
      return PurchaseOptionNotFoundToJSON(value);
    default:
      throw new Error(`No variant of CreatePurchaseQuoteClientError exists with 'code=${value["code"]}'`);
  }
}

// src/models/DisruptionOffer.ts
function instanceOfDisruptionOffer(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function DisruptionOfferFromJSON(json) {
  return DisruptionOfferFromJSONTyped(json, false);
}
function DisruptionOfferFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"]
  };
}
function DisruptionOfferToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id
  };
}

// src/models/Event.ts
function EventFromJSON(json) {
  return EventFromJSONTyped(json, false);
}
function EventFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "cfar_enter_authenticate_page":
      return __spreadProps(__spreadValues({}, CfarEnterAuthenticatePageFromJSONTyped(json, true)), { type: "cfar_enter_authenticate_page" });
    case "cfar_enter_complete_page":
      return __spreadProps(__spreadValues({}, CfarEnterCompletePageFromJSONTyped(json, true)), { type: "cfar_enter_complete_page" });
    case "cfar_enter_contract_page":
      return __spreadProps(__spreadValues({}, CfarEnterContractPageFromJSONTyped(json, true)), { type: "cfar_enter_contract_page" });
    case "cfar_enter_landing_page":
      return __spreadProps(__spreadValues({}, CfarEnterLandingPageFromJSONTyped(json, true)), { type: "cfar_enter_landing_page" });
    case "cfar_enter_payment_error_page":
      return __spreadProps(__spreadValues({}, CfarEnterPaymentErrorPageFromJSONTyped(json, true)), { type: "cfar_enter_payment_error_page" });
    case "cfar_enter_register_page":
      return __spreadProps(__spreadValues({}, CfarEnterRegisterPageFromJSONTyped(json, true)), { type: "cfar_enter_register_page" });
    case "cfar_enter_transfer_method_page":
      return __spreadProps(__spreadValues({}, CfarEnterTransferMethodPageFromJSONTyped(json, true)), { type: "cfar_enter_transfer_method_page" });
    case "cfar_enter_verification_page":
      return __spreadProps(__spreadValues({}, CfarEnterVerificationPageFromJSONTyped(json, true)), { type: "cfar_enter_verification_page" });
    case "cfar_offer_shown":
      return __spreadProps(__spreadValues({}, CfarOfferShownFromJSONTyped(json, true)), { type: "cfar_offer_shown" });
    default:
      throw new Error(`No variant of Event exists with 'type=${json["type"]}'`);
  }
}
function EventToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "cfar_enter_authenticate_page":
      return CfarEnterAuthenticatePageToJSON(value);
    case "cfar_enter_complete_page":
      return CfarEnterCompletePageToJSON(value);
    case "cfar_enter_contract_page":
      return CfarEnterContractPageToJSON(value);
    case "cfar_enter_landing_page":
      return CfarEnterLandingPageToJSON(value);
    case "cfar_enter_payment_error_page":
      return CfarEnterPaymentErrorPageToJSON(value);
    case "cfar_enter_register_page":
      return CfarEnterRegisterPageToJSON(value);
    case "cfar_enter_transfer_method_page":
      return CfarEnterTransferMethodPageToJSON(value);
    case "cfar_enter_verification_page":
      return CfarEnterVerificationPageToJSON(value);
    case "cfar_offer_shown":
      return CfarOfferShownToJSON(value);
    default:
      throw new Error(`No variant of Event exists with 'type=${value["type"]}'`);
  }
}

// src/models/IdentifySessionRequest.ts
function instanceOfIdentifySessionRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "partner_user_id" in value;
  return isInstance;
}
function IdentifySessionRequestFromJSON(json) {
  return IdentifySessionRequestFromJSONTyped(json, false);
}
function IdentifySessionRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "partner_user_id": json["partner_user_id"]
  };
}
function IdentifySessionRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "partner_user_id": value.partner_user_id
  };
}

// src/models/ModelError.ts
function instanceOfModelError(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function ModelErrorFromJSON(json) {
  return ModelErrorFromJSONTyped(json, false);
}
function ModelErrorFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function ModelErrorToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/RefundContractClientError.ts
function RefundContractClientErrorFromJSON(json) {
  return RefundContractClientErrorFromJSONTyped(json, false);
}
function RefundContractClientErrorFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["code"]) {
    case "contract_state_invalid":
      return __spreadProps(__spreadValues({}, ContractStateInvalidFromJSONTyped(json, true)), { code: "contract_state_invalid" });
    default:
      throw new Error(`No variant of RefundContractClientError exists with 'code=${json["code"]}'`);
  }
}
function RefundContractClientErrorToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["code"]) {
    case "contract_state_invalid":
      return ContractStateInvalidToJSON(value);
    default:
      throw new Error(`No variant of RefundContractClientError exists with 'code=${value["code"]}'`);
  }
}

// src/models/Session.ts
function instanceOfSession(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function SessionFromJSON(json) {
  return SessionFromJSONTyped(json, false);
}
function SessionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"]
  };
}
function SessionToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id
  };
}

// src/apis/CancelForAnyReasonCFARApi.ts
var CancelForAnyReasonCFARApi = class extends BaseAPI {
  /**
   * Get a CFAR contract
   * Get a Contract
   */
  getCfarContractsIdRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.hCSessionID === null || requestParameters.hCSessionID === void 0) {
        throw new RequiredError("hCSessionID", "Required parameter requestParameters.hCSessionID was null or undefined when calling getCfarContractsId.");
      }
      if (requestParameters.id === null || requestParameters.id === void 0) {
        throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling getCfarContractsId.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (requestParameters.hCFlagsOverrideID !== void 0 && requestParameters.hCFlagsOverrideID !== null) {
        headerParameters["HC-Flags-Override-ID"] = String(requestParameters.hCFlagsOverrideID);
      }
      if (requestParameters.hCSessionID !== void 0 && requestParameters.hCSessionID !== null) {
        headerParameters["HC-Session-ID"] = String(requestParameters.hCSessionID);
      }
      if (this.configuration && this.configuration.accessToken) {
        headerParameters["Authorization"] = yield this.configuration.accessToken("PartnerAuth", []);
      }
      const response = yield this.request({
        path: `/cfar_contracts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CfarContractFromJSON(jsonValue));
    });
  }
  /**
   * Get a CFAR contract
   * Get a Contract
   */
  getCfarContractsId(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getCfarContractsIdRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create a CFAR contract from a purchased CFAR offer
   * Create a Contract
   */
  postCfarContractsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.hCSessionID === null || requestParameters.hCSessionID === void 0) {
        throw new RequiredError("hCSessionID", "Required parameter requestParameters.hCSessionID was null or undefined when calling postCfarContracts.");
      }
      if (requestParameters.createCfarContractRequest === null || requestParameters.createCfarContractRequest === void 0) {
        throw new RequiredError("createCfarContractRequest", "Required parameter requestParameters.createCfarContractRequest was null or undefined when calling postCfarContracts.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (requestParameters.hCFlagsOverrideID !== void 0 && requestParameters.hCFlagsOverrideID !== null) {
        headerParameters["HC-Flags-Override-ID"] = String(requestParameters.hCFlagsOverrideID);
      }
      if (requestParameters.hCSessionID !== void 0 && requestParameters.hCSessionID !== null) {
        headerParameters["HC-Session-ID"] = String(requestParameters.hCSessionID);
      }
      if (this.configuration && this.configuration.accessToken) {
        headerParameters["Authorization"] = yield this.configuration.accessToken("PartnerAuth", []);
      }
      const response = yield this.request({
        path: `/cfar_contracts`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateCfarContractRequestToJSON(requestParameters.createCfarContractRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CfarContractFromJSON(jsonValue));
    });
  }
  /**
   * Create a CFAR contract from a purchased CFAR offer
   * Create a Contract
   */
  postCfarContracts(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.postCfarContractsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Record that a request to exercise a CFAR contract has occurred
   * Create an Exercise Request
   */
  postCfarExercisesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.hCSessionID === null || requestParameters.hCSessionID === void 0) {
        throw new RequiredError("hCSessionID", "Required parameter requestParameters.hCSessionID was null or undefined when calling postCfarExercises.");
      }
      if (requestParameters.createCfarExerciseRequest === null || requestParameters.createCfarExerciseRequest === void 0) {
        throw new RequiredError("createCfarExerciseRequest", "Required parameter requestParameters.createCfarExerciseRequest was null or undefined when calling postCfarExercises.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (requestParameters.hCFlagsOverrideID !== void 0 && requestParameters.hCFlagsOverrideID !== null) {
        headerParameters["HC-Flags-Override-ID"] = String(requestParameters.hCFlagsOverrideID);
      }
      if (requestParameters.hCSessionID !== void 0 && requestParameters.hCSessionID !== null) {
        headerParameters["HC-Session-ID"] = String(requestParameters.hCSessionID);
      }
      if (this.configuration && this.configuration.accessToken) {
        headerParameters["Authorization"] = yield this.configuration.accessToken("PartnerAuth", []);
      }
      const response = yield this.request({
        path: `/cfar_exercises`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateCfarExerciseRequestToJSON(requestParameters.createCfarExerciseRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CfarExerciseFromJSON(jsonValue));
    });
  }
  /**
   * Record that a request to exercise a CFAR contract has occurred
   * Create an Exercise Request
   */
  postCfarExercises(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.postCfarExercisesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create a CFAR offer for a user\'s trip
   * Create an Offer
   */
  postCfarOffersRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.createCfarOfferRequest === null || requestParameters.createCfarOfferRequest === void 0) {
        throw new RequiredError("createCfarOfferRequest", "Required parameter requestParameters.createCfarOfferRequest was null or undefined when calling postCfarOffers.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (requestParameters.hCFlagsOverrideID !== void 0 && requestParameters.hCFlagsOverrideID !== null) {
        headerParameters["HC-Flags-Override-ID"] = String(requestParameters.hCFlagsOverrideID);
      }
      if (requestParameters.hCSessionID !== void 0 && requestParameters.hCSessionID !== null) {
        headerParameters["HC-Session-ID"] = String(requestParameters.hCSessionID);
      }
      if (this.configuration && this.configuration.accessToken) {
        headerParameters["Authorization"] = yield this.configuration.accessToken("PartnerAuth", []);
      }
      const response = yield this.request({
        path: `/cfar_offers`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateCfarOfferRequestToJSON(requestParameters.createCfarOfferRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CfarOfferFromJSON(jsonValue));
    });
  }
  /**
   * Create a CFAR offer for a user\'s trip
   * Create an Offer
   */
  postCfarOffers(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.postCfarOffersRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create a CFAR purchase quote for a purchase option
   * Create a Purchase Quote
   */
  postCfarPurchaseQuotesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.hCSessionID === null || requestParameters.hCSessionID === void 0) {
        throw new RequiredError("hCSessionID", "Required parameter requestParameters.hCSessionID was null or undefined when calling postCfarPurchaseQuotes.");
      }
      if (requestParameters.createCfarPurchaseQuoteRequest === null || requestParameters.createCfarPurchaseQuoteRequest === void 0) {
        throw new RequiredError("createCfarPurchaseQuoteRequest", "Required parameter requestParameters.createCfarPurchaseQuoteRequest was null or undefined when calling postCfarPurchaseQuotes.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (requestParameters.hCFlagsOverrideID !== void 0 && requestParameters.hCFlagsOverrideID !== null) {
        headerParameters["HC-Flags-Override-ID"] = String(requestParameters.hCFlagsOverrideID);
      }
      if (requestParameters.hCSessionID !== void 0 && requestParameters.hCSessionID !== null) {
        headerParameters["HC-Session-ID"] = String(requestParameters.hCSessionID);
      }
      if (this.configuration && this.configuration.accessToken) {
        headerParameters["Authorization"] = yield this.configuration.accessToken("PartnerAuth", []);
      }
      const response = yield this.request({
        path: `/cfar_purchase_quotes`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateCfarPurchaseQuoteRequestToJSON(requestParameters.createCfarPurchaseQuoteRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CfarPurchaseQuoteFromJSON(jsonValue));
    });
  }
  /**
   * Create a CFAR purchase quote for a purchase option
   * Create a Purchase Quote
   */
  postCfarPurchaseQuotes(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.postCfarPurchaseQuotesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Mark the CFAR contract as refunded, indicating the partner has refunded the premium paid by the user to purchase the CFAR contract
   * Refund a CFAR Contract
   */
  putCfarContractsIdRefundRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.hCSessionID === null || requestParameters.hCSessionID === void 0) {
        throw new RequiredError("hCSessionID", "Required parameter requestParameters.hCSessionID was null or undefined when calling putCfarContractsIdRefund.");
      }
      if (requestParameters.id === null || requestParameters.id === void 0) {
        throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling putCfarContractsIdRefund.");
      }
      if (requestParameters.cfarRefundRequest === null || requestParameters.cfarRefundRequest === void 0) {
        throw new RequiredError("cfarRefundRequest", "Required parameter requestParameters.cfarRefundRequest was null or undefined when calling putCfarContractsIdRefund.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (requestParameters.hCFlagsOverrideID !== void 0 && requestParameters.hCFlagsOverrideID !== null) {
        headerParameters["HC-Flags-Override-ID"] = String(requestParameters.hCFlagsOverrideID);
      }
      if (requestParameters.hCSessionID !== void 0 && requestParameters.hCSessionID !== null) {
        headerParameters["HC-Session-ID"] = String(requestParameters.hCSessionID);
      }
      if (this.configuration && this.configuration.accessToken) {
        headerParameters["Authorization"] = yield this.configuration.accessToken("PartnerAuth", []);
      }
      const response = yield this.request({
        path: `/cfar_contracts/{id}/refund`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: CfarRefundRequestToJSON(requestParameters.cfarRefundRequest)
      }, initOverrides);
      return new VoidApiResponse(response);
    });
  }
  /**
   * Mark the CFAR contract as refunded, indicating the partner has refunded the premium paid by the user to purchase the CFAR contract
   * Refund a CFAR Contract
   */
  putCfarContractsIdRefund(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      yield this.putCfarContractsIdRefundRaw(requestParameters, initOverrides);
    });
  }
  /**
   * Record that a booking associated with a CFAR contract has been canceled
   * Cancel a Booking
   */
  putCfarExercisesIdCancelBookingRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.hCSessionID === null || requestParameters.hCSessionID === void 0) {
        throw new RequiredError("hCSessionID", "Required parameter requestParameters.hCSessionID was null or undefined when calling putCfarExercisesIdCancelBooking.");
      }
      if (requestParameters.id === null || requestParameters.id === void 0) {
        throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling putCfarExercisesIdCancelBooking.");
      }
      if (requestParameters.cfarBookingCanceledRequest === null || requestParameters.cfarBookingCanceledRequest === void 0) {
        throw new RequiredError("cfarBookingCanceledRequest", "Required parameter requestParameters.cfarBookingCanceledRequest was null or undefined when calling putCfarExercisesIdCancelBooking.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (requestParameters.hCFlagsOverrideID !== void 0 && requestParameters.hCFlagsOverrideID !== null) {
        headerParameters["HC-Flags-Override-ID"] = String(requestParameters.hCFlagsOverrideID);
      }
      if (requestParameters.hCSessionID !== void 0 && requestParameters.hCSessionID !== null) {
        headerParameters["HC-Session-ID"] = String(requestParameters.hCSessionID);
      }
      if (this.configuration && this.configuration.accessToken) {
        headerParameters["Authorization"] = yield this.configuration.accessToken("PartnerAuth", []);
      }
      const response = yield this.request({
        path: `/cfar_exercises/{id}/cancel_booking`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: CfarBookingCanceledRequestToJSON(requestParameters.cfarBookingCanceledRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CfarExerciseFromJSON(jsonValue));
    });
  }
  /**
   * Record that a booking associated with a CFAR contract has been canceled
   * Cancel a Booking
   */
  putCfarExercisesIdCancelBooking(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.putCfarExercisesIdCancelBookingRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Record that a request to exercise a CFAR contract has been completed
   * Complete an Exercise
   */
  putCfarExercisesIdCompleteRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.hCSessionID === null || requestParameters.hCSessionID === void 0) {
        throw new RequiredError("hCSessionID", "Required parameter requestParameters.hCSessionID was null or undefined when calling putCfarExercisesIdComplete.");
      }
      if (requestParameters.id === null || requestParameters.id === void 0) {
        throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling putCfarExercisesIdComplete.");
      }
      if (requestParameters.completeCfarExerciseRequest === null || requestParameters.completeCfarExerciseRequest === void 0) {
        throw new RequiredError("completeCfarExerciseRequest", "Required parameter requestParameters.completeCfarExerciseRequest was null or undefined when calling putCfarExercisesIdComplete.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (requestParameters.hCFlagsOverrideID !== void 0 && requestParameters.hCFlagsOverrideID !== null) {
        headerParameters["HC-Flags-Override-ID"] = String(requestParameters.hCFlagsOverrideID);
      }
      if (requestParameters.hCSessionID !== void 0 && requestParameters.hCSessionID !== null) {
        headerParameters["HC-Session-ID"] = String(requestParameters.hCSessionID);
      }
      if (this.configuration && this.configuration.accessToken) {
        headerParameters["Authorization"] = yield this.configuration.accessToken("PartnerAuth", []);
      }
      const response = yield this.request({
        path: `/cfar_exercises/{id}/complete`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: CompleteCfarExerciseRequestToJSON(requestParameters.completeCfarExerciseRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CfarExerciseFromJSON(jsonValue));
    });
  }
  /**
   * Record that a request to exercise a CFAR contract has been completed
   * Complete an Exercise
   */
  putCfarExercisesIdComplete(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.putCfarExercisesIdCompleteRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
};

// src/apis/DisruptionApi.ts
var DisruptionApi = class extends BaseAPI {
  /**
   * Create a disruption offer
   * Create an Offer
   */
  postDisruptionOffersRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.createDisruptionOfferRequest === null || requestParameters.createDisruptionOfferRequest === void 0) {
        throw new RequiredError("createDisruptionOfferRequest", "Required parameter requestParameters.createDisruptionOfferRequest was null or undefined when calling postDisruptionOffers.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (requestParameters.hCFlagsOverrideID !== void 0 && requestParameters.hCFlagsOverrideID !== null) {
        headerParameters["HC-Flags-Override-ID"] = String(requestParameters.hCFlagsOverrideID);
      }
      if (this.configuration && this.configuration.accessToken) {
        headerParameters["Authorization"] = yield this.configuration.accessToken("PartnerAuth", []);
      }
      const response = yield this.request({
        path: `/disruption_offers`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateDisruptionOfferRequestToJSON(requestParameters.createDisruptionOfferRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => DisruptionOfferFromJSON(jsonValue));
    });
  }
  /**
   * Create a disruption offer
   * Create an Offer
   */
  postDisruptionOffers(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.postDisruptionOffersRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
};

// src/apis/SessionsApi.ts
var SessionsApi = class extends BaseAPI {
  /**
   * Create a new event for a given session
   * Create an Event
   */
  postEventsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.event === null || requestParameters.event === void 0) {
        throw new RequiredError("event", "Required parameter requestParameters.event was null or undefined when calling postEvents.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (requestParameters.hCFlagsOverrideID !== void 0 && requestParameters.hCFlagsOverrideID !== null) {
        headerParameters["HC-Flags-Override-ID"] = String(requestParameters.hCFlagsOverrideID);
      }
      if (this.configuration && this.configuration.accessToken) {
        headerParameters["Authorization"] = yield this.configuration.accessToken("PartnerAuth", []);
      }
      const response = yield this.request({
        path: `/events`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: EventToJSON(requestParameters.event)
      }, initOverrides);
      return new VoidApiResponse(response);
    });
  }
  /**
   * Create a new event for a given session
   * Create an Event
   */
  postEvents(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      yield this.postEventsRaw(requestParameters, initOverrides);
    });
  }
  /**
   * Create multiple events in a single batch call
   * Create Events (Batch)
   */
  postEventsBatchRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.event === null || requestParameters.event === void 0) {
        throw new RequiredError("event", "Required parameter requestParameters.event was null or undefined when calling postEventsBatch.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (requestParameters.hCFlagsOverrideID !== void 0 && requestParameters.hCFlagsOverrideID !== null) {
        headerParameters["HC-Flags-Override-ID"] = String(requestParameters.hCFlagsOverrideID);
      }
      if (this.configuration && this.configuration.accessToken) {
        headerParameters["Authorization"] = yield this.configuration.accessToken("PartnerAuth", []);
      }
      const response = yield this.request({
        path: `/events/batch`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters.event.map(EventToJSON)
      }, initOverrides);
      return new VoidApiResponse(response);
    });
  }
  /**
   * Create multiple events in a single batch call
   * Create Events (Batch)
   */
  postEventsBatch(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      yield this.postEventsBatchRaw(requestParameters, initOverrides);
    });
  }
  /**
   * Create a new session
   * Create a Session
   */
  postSessionsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.createSessionRequest === null || requestParameters.createSessionRequest === void 0) {
        throw new RequiredError("createSessionRequest", "Required parameter requestParameters.createSessionRequest was null or undefined when calling postSessions.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (requestParameters.hCFlagsOverrideID !== void 0 && requestParameters.hCFlagsOverrideID !== null) {
        headerParameters["HC-Flags-Override-ID"] = String(requestParameters.hCFlagsOverrideID);
      }
      if (this.configuration && this.configuration.accessToken) {
        headerParameters["Authorization"] = yield this.configuration.accessToken("PartnerAuth", []);
      }
      const response = yield this.request({
        path: `/sessions`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateSessionRequestToJSON(requestParameters.createSessionRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => SessionFromJSON(jsonValue));
    });
  }
  /**
   * Create a new session
   * Create a Session
   */
  postSessions(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.postSessionsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Add a partner user ID for a session that has already been created. This endpoint should be called when a session was created for an anonymous user, but they later login.
   * Identify a Session
   */
  putSessionsIdIdentifyRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.id === null || requestParameters.id === void 0) {
        throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling putSessionsIdIdentify.");
      }
      if (requestParameters.identifySessionRequest === null || requestParameters.identifySessionRequest === void 0) {
        throw new RequiredError("identifySessionRequest", "Required parameter requestParameters.identifySessionRequest was null or undefined when calling putSessionsIdIdentify.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (requestParameters.hCFlagsOverrideID !== void 0 && requestParameters.hCFlagsOverrideID !== null) {
        headerParameters["HC-Flags-Override-ID"] = String(requestParameters.hCFlagsOverrideID);
      }
      if (this.configuration && this.configuration.accessToken) {
        headerParameters["Authorization"] = yield this.configuration.accessToken("PartnerAuth", []);
      }
      const response = yield this.request({
        path: `/sessions/{id}/identify`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: IdentifySessionRequestToJSON(requestParameters.identifySessionRequest)
      }, initOverrides);
      return new VoidApiResponse(response);
    });
  }
  /**
   * Add a partner user ID for a session that has already been created. This endpoint should be called when a session was created for an anonymous user, but they later login.
   * Identify a Session
   */
  putSessionsIdIdentify(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      yield this.putSessionsIdIdentifyRaw(requestParameters, initOverrides);
    });
  }
};
export {
  AnalyticsApplicationErrorFromJSON,
  AnalyticsApplicationErrorFromJSONTyped,
  AnalyticsApplicationErrorToJSON,
  AncillaryFromJSON,
  AncillaryFromJSONTyped,
  AncillaryToJSON,
  AndroidFromJSON,
  AndroidFromJSONTyped,
  AndroidToJSON,
  AppFromJSON,
  AppFromJSONTyped,
  AppToJSON,
  BASE_PATH,
  BaseAPI,
  BlobApiResponse,
  BrowserFromJSON,
  BrowserFromJSONTyped,
  BrowserToJSON,
  COLLECTION_FORMATS,
  CancelBookingFailedFromJSON,
  CancelBookingFailedFromJSONTyped,
  CancelBookingFailedToJSON,
  CancelForAnyReasonCFARApi,
  CfarBookingCanceledRequestFromJSON,
  CfarBookingCanceledRequestFromJSONTyped,
  CfarBookingCanceledRequestToJSON,
  CfarContractFromJSON,
  CfarContractFromJSONTyped,
  CfarContractToJSON,
  CfarEnterAuthenticatePageFromJSON,
  CfarEnterAuthenticatePageFromJSONTyped,
  CfarEnterAuthenticatePageToJSON,
  CfarEnterCompletePageFromJSON,
  CfarEnterCompletePageFromJSONTyped,
  CfarEnterCompletePageToJSON,
  CfarEnterContractPageFromJSON,
  CfarEnterContractPageFromJSONTyped,
  CfarEnterContractPageToJSON,
  CfarEnterLandingPageFromJSON,
  CfarEnterLandingPageFromJSONTyped,
  CfarEnterLandingPageToJSON,
  CfarEnterPaymentErrorPageFromJSON,
  CfarEnterPaymentErrorPageFromJSONTyped,
  CfarEnterPaymentErrorPageToJSON,
  CfarEnterRegisterPageFromJSON,
  CfarEnterRegisterPageFromJSONTyped,
  CfarEnterRegisterPageToJSON,
  CfarEnterTransferMethodPageFromJSON,
  CfarEnterTransferMethodPageFromJSONTyped,
  CfarEnterTransferMethodPageToJSON,
  CfarEnterVerificationPageFromJSON,
  CfarEnterVerificationPageFromJSONTyped,
  CfarEnterVerificationPageToJSON,
  CfarExerciseFromJSON,
  CfarExerciseFromJSONTyped,
  CfarExerciseToJSON,
  CfarFareFromJSON,
  CfarFareFromJSONTyped,
  CfarFareSliceFromJSON,
  CfarFareSliceFromJSONTyped,
  CfarFareSliceSegmentFromJSON,
  CfarFareSliceSegmentFromJSONTyped,
  CfarFareSliceSegmentToJSON,
  CfarFareSliceToJSON,
  CfarFareToJSON,
  CfarOfferFromJSON,
  CfarOfferFromJSONTyped,
  CfarOfferShownFromJSON,
  CfarOfferShownFromJSONTyped,
  CfarOfferShownToJSON,
  CfarOfferToJSON,
  CfarPurchaseOptionFromJSON,
  CfarPurchaseOptionFromJSONTyped,
  CfarPurchaseOptionToJSON,
  CfarPurchaseQuoteFromJSON,
  CfarPurchaseQuoteFromJSONTyped,
  CfarPurchaseQuoteToJSON,
  CfarRefundFromJSON,
  CfarRefundFromJSONTyped,
  CfarRefundReasonFromJSON,
  CfarRefundReasonFromJSONTyped,
  CfarRefundReasonToJSON,
  CfarRefundRequestFromJSON,
  CfarRefundRequestFromJSONTyped,
  CfarRefundRequestToJSON,
  CfarRefundToJSON,
  ChromeFromJSON,
  ChromeFromJSONTyped,
  ChromeOsFromJSON,
  ChromeOsFromJSONTyped,
  ChromeOsToJSON,
  ChromeToJSON,
  ClientErrorFromJSON,
  ClientErrorFromJSONTyped,
  ClientErrorToJSON,
  CompleteCfarExerciseRequestFromJSON,
  CompleteCfarExerciseRequestFromJSONTyped,
  CompleteCfarExerciseRequestToJSON,
  CompleteExerciseClientErrorFromJSON,
  CompleteExerciseClientErrorFromJSONTyped,
  CompleteExerciseClientErrorToJSON,
  Configuration,
  ContractNotFound1FromJSON,
  ContractNotFound1FromJSONTyped,
  ContractNotFound1ToJSON,
  ContractNotFoundFromJSON,
  ContractNotFoundFromJSONTyped,
  ContractNotFoundToJSON,
  ContractStateInvalidFromJSON,
  ContractStateInvalidFromJSONTyped,
  ContractStateInvalidToJSON,
  CreateCfarContractRequestFromJSON,
  CreateCfarContractRequestFromJSONTyped,
  CreateCfarContractRequestToJSON,
  CreateCfarExerciseRequestFromJSON,
  CreateCfarExerciseRequestFromJSONTyped,
  CreateCfarExerciseRequestToJSON,
  CreateCfarOfferRequestFromJSON,
  CreateCfarOfferRequestFromJSONTyped,
  CreateCfarOfferRequestToJSON,
  CreateCfarPurchaseQuoteRequestFromJSON,
  CreateCfarPurchaseQuoteRequestFromJSONTyped,
  CreateCfarPurchaseQuoteRequestToJSON,
  CreateContractClientErrorFromJSON,
  CreateContractClientErrorFromJSONTyped,
  CreateContractClientErrorToJSON,
  CreateDisruptionOfferRequestFromJSON,
  CreateDisruptionOfferRequestFromJSONTyped,
  CreateDisruptionOfferRequestToJSON,
  CreateExerciseClientErrorFromJSON,
  CreateExerciseClientErrorFromJSONTyped,
  CreateExerciseClientErrorToJSON,
  CreateOfferClientErrorFromJSON,
  CreateOfferClientErrorFromJSONTyped,
  CreateOfferClientErrorToJSON,
  CreatePurchaseQuoteClientErrorFromJSON,
  CreatePurchaseQuoteClientErrorFromJSONTyped,
  CreatePurchaseQuoteClientErrorToJSON,
  CreateSessionRequestFromJSON,
  CreateSessionRequestFromJSONTyped,
  CreateSessionRequestToJSON,
  DefaultConfig,
  DesktopFromJSON,
  DesktopFromJSONTyped,
  DesktopToJSON,
  DeviceFromJSON,
  DeviceFromJSONTyped,
  DeviceToJSON,
  DisruptionApi,
  DisruptionOfferFromJSON,
  DisruptionOfferFromJSONTyped,
  DisruptionOfferToJSON,
  EdgeFromJSON,
  EdgeFromJSONTyped,
  EdgeToJSON,
  EmailFailureFromJSON,
  EmailFailureFromJSONTyped,
  EmailFailureToJSON,
  EventFromJSON,
  EventFromJSONTyped,
  EventToJSON,
  ExerciseAlreadyCompletedFromJSON,
  ExerciseAlreadyCompletedFromJSONTyped,
  ExerciseAlreadyCompletedToJSON,
  ExerciseNotFoundFromJSON,
  ExerciseNotFoundFromJSONTyped,
  ExerciseNotFoundToJSON,
  FareClass,
  FareClassFromJSON,
  FareClassFromJSONTyped,
  FareClassToJSON,
  FetchError,
  FirefoxFromJSON,
  FirefoxFromJSONTyped,
  FirefoxToJSON,
  IOsFromJSON,
  IOsFromJSONTyped,
  IOsToJSON,
  IdentifySessionRequestFromJSON,
  IdentifySessionRequestFromJSONTyped,
  IdentifySessionRequestToJSON,
  InternetExplorerFromJSON,
  InternetExplorerFromJSONTyped,
  InternetExplorerToJSON,
  InvalidAirportCodeFromJSON,
  InvalidAirportCodeFromJSONTyped,
  InvalidAirportCodeToJSON,
  InvalidCompletedDateTimeFromJSON,
  InvalidCompletedDateTimeFromJSONTyped,
  InvalidCompletedDateTimeToJSON,
  InvalidCurrencyFromJSON,
  InvalidCurrencyFromJSONTyped,
  InvalidCurrencyToJSON,
  InvalidFarePriceFromJSON,
  InvalidFarePriceFromJSONTyped,
  InvalidFarePriceToJSON,
  InvalidFareSlicesFromJSON,
  InvalidFareSlicesFromJSONTyped,
  InvalidFareSlicesToJSON,
  InvalidInitiatedDateTimeFromJSON,
  InvalidInitiatedDateTimeFromJSONTyped,
  InvalidInitiatedDateTimeToJSON,
  InvalidLocaleFromJSON,
  InvalidLocaleFromJSONTyped,
  InvalidLocaleToJSON,
  InvalidPassengerCountsFromJSON,
  InvalidPassengerCountsFromJSONTyped,
  InvalidPassengerCountsToJSON,
  InvalidRefundFromJSON,
  InvalidRefundFromJSONTyped,
  InvalidRefundToJSON,
  InvalidStateFromJSON,
  InvalidStateFromJSONTyped,
  InvalidStateToJSON,
  JSONApiResponse,
  LinuxFromJSON,
  LinuxFromJSONTyped,
  LinuxToJSON,
  LuggageFromJSON,
  LuggageFromJSONTyped,
  LuggageToJSON,
  MacOsFromJSON,
  MacOsFromJSONTyped,
  MacOsToJSON,
  MobileFromJSON,
  MobileFromJSONTyped,
  MobileToJSON,
  ModelErrorFromJSON,
  ModelErrorFromJSONTyped,
  ModelErrorToJSON,
  OfferExpiredFromJSON,
  OfferExpiredFromJSONTyped,
  OfferExpiredToJSON,
  OfferNotCreatedFromJSON,
  OfferNotCreatedFromJSONTyped,
  OfferNotCreatedToJSON,
  OfferNotFound1FromJSON,
  OfferNotFound1FromJSONTyped,
  OfferNotFound1ToJSON,
  OfferNotFoundFromJSON,
  OfferNotFoundFromJSONTyped,
  OfferNotFoundToJSON,
  OfflineReconciliationFromJSON,
  OfflineReconciliationFromJSONTyped,
  OfflineReconciliationToJSON,
  OperaFromJSON,
  OperaFromJSONTyped,
  OperaToJSON,
  OperatingSystemFromJSON,
  OperatingSystemFromJSONTyped,
  OperatingSystemToJSON,
  OtherBrowserFromJSON,
  OtherBrowserFromJSONTyped,
  OtherBrowserToJSON,
  OtherFromJSON,
  OtherFromJSONTyped,
  OtherOsFromJSON,
  OtherOsFromJSONTyped,
  OtherOsToJSON,
  OtherToJSON,
  PartnerUserFromJSON,
  PartnerUserFromJSONTyped,
  PartnerUserNotFoundFromJSON,
  PartnerUserNotFoundFromJSONTyped,
  PartnerUserNotFoundToJSON,
  PartnerUserToJSON,
  PassengerFromJSON,
  PassengerFromJSONTyped,
  PassengerToJSON,
  PassengerType,
  PassengerTypeFromJSON,
  PassengerTypeFromJSONTyped,
  PassengerTypeToJSON,
  PaymentMethodFromJSON,
  PaymentMethodFromJSONTyped,
  PaymentMethodToJSON,
  PlatformFromJSON,
  PlatformFromJSONTyped,
  PlatformToJSON,
  PurchaseOptionNotFoundFromJSON,
  PurchaseOptionNotFoundFromJSONTyped,
  PurchaseOptionNotFoundToJSON,
  PurchaseQuoteAlreadyPurchasedFromJSON,
  PurchaseQuoteAlreadyPurchasedFromJSONTyped,
  PurchaseQuoteAlreadyPurchasedToJSON,
  PurchaseQuoteNotFoundFromJSON,
  PurchaseQuoteNotFoundFromJSONTyped,
  PurchaseQuoteNotFoundToJSON,
  RefundContractClientErrorFromJSON,
  RefundContractClientErrorFromJSONTyped,
  RefundContractClientErrorToJSON,
  RequiredError,
  ResponseError,
  SafariFromJSON,
  SafariFromJSONTyped,
  SafariToJSON,
  SeatSelectionFromJSON,
  SeatSelectionFromJSONTyped,
  SeatSelectionToJSON,
  ServerFromJSON,
  ServerFromJSONTyped,
  ServerToJSON,
  SessionFromJSON,
  SessionFromJSONTyped,
  SessionIdOrCreateSessionRequestRequiredFromJSON,
  SessionIdOrCreateSessionRequestRequiredFromJSONTyped,
  SessionIdOrCreateSessionRequestRequiredToJSON,
  SessionToJSON,
  SessionsApi,
  State,
  StateFromJSON,
  StateFromJSONTyped,
  StateToJSON,
  TabletFromJSON,
  TabletFromJSONTyped,
  TabletToJSON,
  TextApiResponse,
  TicketingFailureFromJSON,
  TicketingFailureFromJSONTyped,
  TicketingFailureToJSON,
  TravelInsuranceFromJSON,
  TravelInsuranceFromJSONTyped,
  TravelInsuranceToJSON,
  UnclassifiedFromJSON,
  UnclassifiedFromJSONTyped,
  UnclassifiedToJSON,
  UnsupportedPriceFreezeOfferTypeFromJSON,
  UnsupportedPriceFreezeOfferTypeFromJSONTyped,
  UnsupportedPriceFreezeOfferTypeToJSON,
  VoidApiResponse,
  VoidWindowFromJSON,
  VoidWindowFromJSONTyped,
  VoidWindowToJSON,
  WebFromJSON,
  WebFromJSONTyped,
  WebToJSON,
  WindowsFromJSON,
  WindowsFromJSONTyped,
  WindowsToJSON,
  canConsumeForm,
  exists,
  instanceOfAndroid,
  instanceOfApp,
  instanceOfCancelBookingFailed,
  instanceOfCfarBookingCanceledRequest,
  instanceOfCfarContract,
  instanceOfCfarEnterAuthenticatePage,
  instanceOfCfarEnterCompletePage,
  instanceOfCfarEnterContractPage,
  instanceOfCfarEnterLandingPage,
  instanceOfCfarEnterPaymentErrorPage,
  instanceOfCfarEnterRegisterPage,
  instanceOfCfarEnterTransferMethodPage,
  instanceOfCfarEnterVerificationPage,
  instanceOfCfarExercise,
  instanceOfCfarFare,
  instanceOfCfarFareSlice,
  instanceOfCfarFareSliceSegment,
  instanceOfCfarOffer,
  instanceOfCfarOfferShown,
  instanceOfCfarPurchaseOption,
  instanceOfCfarPurchaseQuote,
  instanceOfCfarRefund,
  instanceOfCfarRefundRequest,
  instanceOfChrome,
  instanceOfChromeOs,
  instanceOfCompleteCfarExerciseRequest,
  instanceOfContractNotFound,
  instanceOfContractNotFound1,
  instanceOfContractStateInvalid,
  instanceOfCreateCfarContractRequest,
  instanceOfCreateCfarExerciseRequest,
  instanceOfCreateCfarOfferRequest,
  instanceOfCreateCfarPurchaseQuoteRequest,
  instanceOfCreateDisruptionOfferRequest,
  instanceOfCreateSessionRequest,
  instanceOfDesktop,
  instanceOfDisruptionOffer,
  instanceOfEdge,
  instanceOfEmailFailure,
  instanceOfExerciseAlreadyCompleted,
  instanceOfExerciseNotFound,
  instanceOfFirefox,
  instanceOfIOs,
  instanceOfIdentifySessionRequest,
  instanceOfInternetExplorer,
  instanceOfInvalidAirportCode,
  instanceOfInvalidCompletedDateTime,
  instanceOfInvalidCurrency,
  instanceOfInvalidFarePrice,
  instanceOfInvalidFareSlices,
  instanceOfInvalidInitiatedDateTime,
  instanceOfInvalidLocale,
  instanceOfInvalidPassengerCounts,
  instanceOfInvalidRefund,
  instanceOfInvalidState,
  instanceOfLinux,
  instanceOfLuggage,
  instanceOfMacOs,
  instanceOfMobile,
  instanceOfModelError,
  instanceOfOfferExpired,
  instanceOfOfferNotCreated,
  instanceOfOfferNotFound,
  instanceOfOfferNotFound1,
  instanceOfOfflineReconciliation,
  instanceOfOpera,
  instanceOfOther,
  instanceOfOtherBrowser,
  instanceOfOtherOs,
  instanceOfPartnerUser,
  instanceOfPartnerUserNotFound,
  instanceOfPassenger,
  instanceOfPurchaseOptionNotFound,
  instanceOfPurchaseQuoteAlreadyPurchased,
  instanceOfPurchaseQuoteNotFound,
  instanceOfSafari,
  instanceOfSeatSelection,
  instanceOfServer,
  instanceOfSession,
  instanceOfSessionIdOrCreateSessionRequestRequired,
  instanceOfTablet,
  instanceOfTicketingFailure,
  instanceOfTravelInsurance,
  instanceOfUnclassified,
  instanceOfUnsupportedPriceFreezeOfferType,
  instanceOfVoidWindow,
  instanceOfWeb,
  instanceOfWindows,
  mapValues,
  querystring
};
//# sourceMappingURL=index.mjs.map